/* ============================================================
   OPTION DE CONFECTION — Patch panier v3 (classique par défaut)
   ============================================================ */

(function patchOptionConfection() {

  function getAddonButtons() {
    return Array.from(document.querySelectorAll('[class*="ai-addon-selector__button-"]'));
  }

  function parsePriceTextToCents(text) {
    if (!text) return 0;
    let s = String(text)
      .replace(/ /g, ' ')
      .replace(/€/g, '')
      .replace(/,/g, '.')
      .trim();

    const match = s.match(/-?\d+(?:\.\d{1,2})?/);
    if (!match) return 0;
    const amount = Number(match[0]);
    if (!Number.isFinite(amount)) return 0;
    return Math.round(amount * 100);
  }

  function normalizeAddonLabel(title) {
    const t = String(title || '').trim();
    if (!t) return 'Classique';

    const normalized = t
      .normalize('NFD').replace(/[̀-ͯ]/g, '')
      .toLowerCase()
      .replace(/\s+/g, ' ')
      .trim();

    if (normalized.includes('ultraexpress') || (normalized.includes('ultra') && normalized.includes('express'))) {
      return 'UltraExpress';
    }
    if (normalized.includes('express')) {
      return 'Express';
    }
    if (normalized.includes('classique')) {
      return 'Classique';
    }

    const cleaned = t.replace(/^option\s+confection\s*/i, '').trim();
    return cleaned || t;
  }

  function buildAddonInfoFromButton(btn) {
    if (!btn) return null;
    const titleEl = btn.querySelector('[class*="ai-addon-selector__button-title-"]');
    const descEl = btn.querySelector('[class*="ai-addon-selector__button-description-"]');
    const priceEl = btn.querySelector('[class*="ai-addon-selector__button-price-"]');
    const title = titleEl ? titleEl.textContent.trim() : '';
    const description = descEl ? descEl.textContent.trim() : '';
    const priceText = priceEl ? priceEl.textContent.trim() : '';
    const variantRaw = btn.dataset.variantId || btn.getAttribute('data-variant-id') || '';
    const variantId = Number(variantRaw);
    const hasVariant = Number.isFinite(variantId) && variantId > 0;
    const baseLabel = normalizeAddonLabel(title);
    const timeLabel = description || '';
    const label = timeLabel ? `${baseLabel} · ${timeLabel}` : baseLabel;
    return {
      button: btn,
      variantId: hasVariant ? variantId : 0,
      hasVariant,
      isClassic: btn.dataset.classicDefault === 'true' || !hasVariant,
      title,
      description,
      label,
      price: priceText,
      priceCents: parsePriceTextToCents(priceText)
    };
  }

  function getDefaultClassicButton() {
    return document.querySelector('[data-classic-default="true"]');
  }

  function getSelectedAddonButton() {
    return getAddonButtons().find(btn => btn.classList.contains('selected')) || null;
  }

  function getSelectedAddonInfo() {
    return buildAddonInfoFromButton(getSelectedAddonButton() || getDefaultClassicButton());
  }

  function ensureSingleAddonSelection(selectedBtn) {
    const fallback = selectedBtn || getDefaultClassicButton() || getAddonButtons()[0] || null;
    const buttons = getAddonButtons();
    buttons.forEach(btn => {
      const isSelected = btn === fallback;
      btn.classList.toggle('selected', isSelected);
      btn.classList.toggle('active', isSelected);
      btn.classList.toggle('is-selected', isSelected);
      btn.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
      btn.dataset.selected = isSelected ? 'true' : 'false';
    });
    return fallback;
  }

  function emitAddonChange() {
    document.dispatchEvent(new CustomEvent('sissou:addon-selection-changed', {
      detail: getSelectedAddonInfo()
    }));
  }

  function setupSingleSelectionBehaviour() {
    if (document.documentElement.dataset.sissouAddonSingleSelectionReady === 'true') return;
    document.documentElement.dataset.sissouAddonSingleSelectionReady = 'true';

    document.addEventListener('click', function(ev) {
      const btn = ev.target.closest('[class*="ai-addon-selector__button-"]');
      if (!btn) return;

      setTimeout(() => {
        ensureSingleAddonSelection(btn);
        emitAddonChange();
      }, 0);
    }, true);

    setTimeout(() => {
      const selected = getAddonButtons().filter(btn => btn.classList.contains('selected'));
      ensureSingleAddonSelection(selected[selected.length - 1] || getDefaultClassicButton());
      emitAddonChange();
    }, 0);
  }

  window.SISSOU_OPTION_CONFECTION = {
    getSelectedAddonInfo,
    getSelectedAddonPriceCents() {
      const info = getSelectedAddonInfo();
      return info ? info.priceCents : 0;
    },
    getSelectedAddonLabel() {
      const info = getSelectedAddonInfo();
      return info ? info.label : 'Classique · 4 semaines';
    },
    refreshSelection: setupSingleSelectionBehaviour
  };

  setupSingleSelectionBehaviour();

  const _fetch = window.fetch;
window.fetch = function(url, options, ...rest) {
  if (typeof url === 'string' && url.includes('/cart/add')) {
    try {
      const addonInfo = getSelectedAddonInfo();

      if (addonInfo && options && options.body) {
        const isString = typeof options.body === 'string';
        let body = isString ? JSON.parse(options.body) : options.body;

        const bundleUid = 'bundle_' + Date.now() + '_' + Math.random().toString(36).slice(2, 10);
        const label = addonInfo.label || 'Confection classique';

        const decorateItem = (item, defaultRole = 'parent') => {
          const originalProperties = item.properties || {};
          const role = originalProperties._bundle_role || defaultRole;
          const isMini = role === 'mini';
          const isAddon = role === 'addon';

          const properties = {
            ...originalProperties,
            '_bundle_uid': originalProperties._bundle_uid || bundleUid,
            '_bundle_role': role
          };

          if(!isMini && !isAddon){
            properties['Option de confection'] = label;
          }

          return {
            ...item,
            properties
          };
        };

        const buildAddonItem = () => ({
          id: addonInfo.variantId,
          quantity: 1,
          properties: {
            '_bundle_uid': bundleUid,
            '_bundle_role': 'addon',
            '_option_confection': addonInfo.title
          }
        });

        if (body.items && Array.isArray(body.items)) {
          body.items = body.items.map(item => decorateItem(item));

          if (addonInfo.variantId) {
            body.items.push(buildAddonItem());
          }

        } else if (body.id) {
          const originalProperties = body.properties || {};
          const role = originalProperties._bundle_role || 'parent';

          const mainItem = decorateItem({
            id: body.id,
            quantity: body.quantity || 1,
            properties: originalProperties
          }, role);

          body = addonInfo.variantId && role !== 'mini'
            ? {
                items: [
                  mainItem,
                  buildAddonItem()
                ]
              }
            : mainItem;
        }

        options = { ...options, body: isString ? JSON.stringify(body) : body };
      }
    } catch(e) {
      console.warn('[Sissou] Option confection patch error:', e);
    }
  }

  return _fetch.call(this, url, options, ...rest);
};

})();


/******************************************************************
 * CONFIGURATEUR TRESSE — JS COMPLET
 * + Motifs pour "lisse_synthetique" via JPG dédiés par tissu
 * ✅ MAJ MOTIFS (sans spritesheet, anti-bords, tuilage décalé)
 ******************************************************************/

/******************************************************************
 * OUTILS PRIX SHOPIFY
 ******************************************************************/
const _variantPriceCache = new Map();

function formatMoneyCents(cents){
  if(cents == null) return "—";
  const n = Number(cents) / 100;
  return n.toLocaleString("fr-FR", { style: "currency", currency: "EUR" });
}

async function getVariantPrice(variantId){
  if(!variantId) return null;
  if(_variantPriceCache.has(variantId)) return _variantPriceCache.get(variantId);

  try{
    const res = await fetch(`/variants/${variantId}.js`, { credentials: "same-origin" });
    if(!res.ok) throw new Error("variant fetch failed");
    const data = await res.json();
    const price = (data && typeof data.price === "number") ? data.price : null;

    _variantPriceCache.set(variantId, price);
    return price;
  }catch(e){
    console.warn("Impossible de récupérer le prix variante", variantId, e);
    _variantPriceCache.set(variantId, null);
    return null;
  }
}

/******************************************************************
 * BRAID (objet global)
 ******************************************************************/
const BRAID = {
  type: "3",
  get strandCount(){
    return this.type === "4" ? 4 : (this.type === "5" ? 5 : 3);
  },
  renderSettings: {
    base: { thicknessMul: 1.0, amplitudeMul: 1.0, highlightMul: 1.0, textureZoom: 0.92 },
    "3":    { thicknessMul: 1.0, amplitudeMul: 1.0, highlightMul: 1.0, textureZoom: 0.92 },
    "4":    { thicknessMul: 1.0, amplitudeMul: 1.0, highlightMul: 1.0, textureZoom: 0.92 },
    "5":    { thicknessMul: 1.0, amplitudeMul: 1.0, highlightMul: 1.0, textureZoom: 0.92 },
    "3xxl": { thicknessMul: 1.35, amplitudeMul: 1.20, highlightMul: 1.05, textureZoom: 1.02 }
  },

  currentFabricKey: "nid_abeille_coton",
  currentFabricLabel: "Nid d'abeille · coton Oeko-Tex",
  currentPaletteText: "—",

  currentFabrics: {},
  currentColors: {},
  currentMotifs: {},

  previewEnabled: true,
  missingAssets: []
};

function braidTypeLabel(type){
  if(type === "3") return "Tresse 3 brins";
  if(type === "4") return "Tresse 4 brins";
  if(type === "5") return "Tresse 5 brins";
  if(type === "3xxl") return "Tresse 3 brins XXL";
  return "Tresse";
}

function getBraidSettings(){
  const base = BRAID.renderSettings.base;
  const ov = BRAID.renderSettings[BRAID.type] || {};
  return { ...base, ...ov };
}
/******************************************************************
 * PART A — Lit + segments + tranches de prix
 * ✅ Lit photo FIXE (background)
 * ✅ Zones cliquables FIXES (collées aux barreaux)
 * ✅ Changer la taille (L/l) = UNIQUEMENT pour calcul tranche/variant
 * ❌ La taille n’influence PLUS le visuel, ni les zones, ni les labels
 ******************************************************************/

/* =========================
   Prix / presets
========================= */
const PRICE_RANGES = [
  { min: 30,  max: 110 },
  { min: 110, max: 200 },
  { min: 210, max: 250 },
  { min: 260, max: 300 },
  { min: 310, max: 360 },
  { min: 370, max: 420 },
  { min: 430, max: 480 },
  { min: 490, max: 540 },
  { min: 550, max: 600 },
  { min: 610, max: 660 },
];

const PRESETS = {
  "Lit bébé":   [{ L: 120, l: 60 }, { L: 140, l: 70 }],
  "Lit enfant": [{ L: 160, l: 70 }, { L: 160, l: 80 }],
  "Lit cabane": [{ L: 190, l: 90 }, { L: 200, l: 90 }, { L: 200, l: 100 }],
  "Lit 1 place":[{ L: 190, l: 90 }, { L: 200, l: 90 }, { L: 190, l: 120 }],
};

/* =========================
   State
========================= */
const bedState = {
  bedType: "Lit bébé",
  L: 120,
  l: 60,
  margin: 0,
  mode: "known_size", // simplifié : saisie manuelle uniquement
  knownSizeCm: null,
  segments: { head:false, foot:false, left:false, right:false }, // head=TÊTE, foot=PIED, left=CÔTÉ GAUCHE, right=CÔTÉ DROIT
  anim:     { head:0,      foot:0,      left:0,      right:0 },
  lastFrame: performance.now(),
  presetIndex: 0
};

const clamp = (v, a, b) => Math.max(a, Math.min(b, v));
const roundUp10 = (cm) => Math.ceil(cm / 10) * 10;
const roundDown10 = (cm) => Math.floor(cm / 10) * 10;
const formatRange = (r) => `${r.min}cm à ${r.max}cm`;

function getSelectedSegmentsList(){
  const map = { head:"Tête", foot:"Pied", left:"Côté gauche", right:"Côté droit" };
  return Object.keys(bedState.segments).filter(k => bedState.segments[k]).map(k => map[k]);
}

function findRangeForLength(cmRounded){
  for(const r of PRICE_RANGES){
    if(cmRounded >= r.min && cmRounded <= r.max) return r;
  }
  return null;
}

/**
 * ✅ Le calcul longueur/prix CONTINUE d'utiliser L/l
 * (même si le visuel est fixe)
 */
function computeLengths(){
  if(bedState.mode === "known_size" && bedState.knownSizeCm){
    const raw = Number(bedState.knownSizeCm) || 0;
    const rounded = raw ? roundDown10(raw) : 0;
    const range = rounded ? findRangeForLength(rounded) : null;
    return { raw, withMargin: raw, rounded, range };
  }

  const {L, l} = bedState;
  let raw = 0;

  // head/foot = largeur ; left/right = longueur (logique métier inchangée)
  if(bedState.segments.head)  raw += l;
  if(bedState.segments.foot)  raw += l;
  if(bedState.segments.left)  raw += L;
  if(bedState.segments.right) raw += L;

  const rounded = raw ? roundUp10(raw) : 0;
  const range = rounded ? findRangeForLength(rounded) : null;
  return { raw, withMargin: raw, rounded, range };
}

function safeDims(){
  // ✅ uniquement pour calcul/prix/variant
  bedState.L = clamp(Math.round(bedState.L || 0), 30, 400);
  bedState.l = clamp(Math.round(bedState.l || 0), 30, 250);
}

/* =========================
   Mapping variantes Shopify (window.SISSOU_PRODUCTS)
========================= */
function resolveVariantIdFromRoundedLength(braidType, roundedCm){
  const cfg = (window.SISSOU_PRODUCTS && window.SISSOU_PRODUCTS[braidType]) || null;
  if(!cfg || !cfg.ranges) return null;

  let cm = Number(roundedCm);
  if(cm > 200 && cm < 210) cm = 210;

  const hit = cfg.ranges.find(r => cm >= r.min && cm <= r.max);
  return hit ? hit.variantId : null;
}

/* =========================
   DOM (bed)
========================= */
const tresseEntryCard = document.getElementById("tresseEntryCard");
const knownTresseSizeInput = document.getElementById("knownTresseSize");
const knownTresseSizeError = document.getElementById("knownTresseSizeError");
const knownTresseSizeContinue = document.getElementById("knownTresseSizeContinue");
const needHelpTresseBtn = document.getElementById("needHelpTresseBtn");
const needHelpTresseMsg = document.getElementById("needHelpTresseMsg");

const HELP_PRESETS = [
  {
    title: 'Lit 120 × 60 cm',
    items: [
      { label: 'Tour complet', value: 360 },
      { label: '3 principaux côtés', value: 300 },
      { label: 'Moitié', value: 180 }
    ]
  },
  {
    title: 'Lit 140 × 70 cm',
    items: [
      { label: 'Tour complet', value: 420 },
      { label: '3 principaux côtés', value: 350 },
      { label: 'Moitié', value: 210 }
    ]
  },
  {
    title: 'Lit 80 × 160 cm',
    items: [
      { label: 'Tour complet', value: 480 },
      { label: '3 principaux côtés', value: 400 },
      { label: 'Tour complet ouverture moitié', value: 400 },
      { label: 'Moitié', value: 240 }
    ]
  },
  {
    title: 'Lit 140 × 190 cm',
    items: [
      { label: 'Tour complet', value: 660 },
      { label: 'Petite ouverture 40 cm', value: 620 },
      { label: 'Ouverture moyenne 60 cm', value: 600 },
      { label: 'Grande ouverture 100 cm', value: 560 },      
      { label: 'Moitié', value: 330 }
    ]
  },
  {
    title: 'Lit 190 × 90 cm',
    items: [
      { label: 'Tour complet', value: 560 },
      { label: 'Petite ouverture 40 cm', value: 520 },
      { label: 'Ouverture moyenne 60 cm', value: 500 },      
      { label: 'Grande ouverture 100 cm', value: 460 },
      { label: 'Lit Bosco Atmosphera', value: 460 }
    ]
  },
  {
    title: 'Parc',
    items: [
      { label: '100 × 100 cm', value: 400 },
      { label: '100 × 80 cm', value: 360 },
      { label: '100 × 70 cm', value: 340 },                  
      { label: '80 × 80 cm', value: 320 }
    ]
  }
];

const HELP_HEIGHTS = [
  '3 brins · 15 cm',
  '4 brins · 19 cm',
  '5 brins · 24 cm',
  '3 brins XXL · 26 cm'
];

let helpPresetsBuilt = false;
const mainConfiguratorCard = document.getElementById("mainConfiguratorCard");
const knownSizeBackBtn = document.getElementById("knownSizeBackBtn");
const mainAddBtn = document.getElementById("mainAddBtn");

const miniBraidCheckbox = document.getElementById("miniBraidCheckbox");
const miniBraidPriceEl = document.getElementById("miniBraidPrice");
const scrollPourInfoBtn = document.getElementById("scrollPourInfoBtn");

const MINI_BRAID_BY_TYPE = {
  "3": {
    title: "Mini tresse 3 brins",
    variantId: 53644287115602,
    priceCents: 1500
  },
  "4": {
    title: "Mini tresse 4 brins",
    variantId: 53644288164178,
    priceCents: 2000
  },
  "5": {
    title: "Mini tresse 5 brins",
    variantId: 53644289900882,
    priceCents: 2500
  },
  "3xxl": {
    title: "Mini tresse 3 XXL brins",
    variantId: 53644291506514,
    priceCents: 3000
  }
};

function getMiniBraidInfo(type = BRAID.type){
  return MINI_BRAID_BY_TYPE[type] || null;
}

function isMiniBraidSelected(){
  return !!(miniBraidCheckbox && miniBraidCheckbox.checked);
}

function getMiniBraidPriceCents(){
  const info = getMiniBraidInfo();
  return isMiniBraidSelected() && info ? info.priceCents : 0;
}

function refreshMiniBraidOption(){
  const info = getMiniBraidInfo();

  if(miniBraidPriceEl){
    miniBraidPriceEl.textContent = info ? `+ ${formatMoneyCents(info.priceCents)}` : "";
  }
}

function findPourInfoSection(){
  const byShopifyId = document.querySelector('[id*="collapsible_content_w9m7dR"]');
  if(byShopifyId) return byShopifyId;

  const headings = Array.from(document.querySelectorAll('h1, h2, h3, .title, .heading, .collapsible-content__heading'));
  const heading = headings.find(el => {
    return String(el.textContent || "").trim().toLowerCase() === "pour info";
  });

  return heading ? heading.closest('.shopify-section, section, .section, div') : null;
}

function scrollToPourInfo(){
  const target = findPourInfoSection();

  if(!target){
    console.warn('[Sissou] Section Pour info introuvable.');
    return;
  }

  const offset = 120;
  const top = target.getBoundingClientRect().top + window.pageYOffset - offset;

  window.scrollTo({
    top,
    behavior: "smooth"
  });
}

const _fallbackEl = (tag = "div") => document.createElement(tag);
const _fallbackCanvas = (() => {
  const c = document.createElement("canvas");
  c.width = 1;
  c.height = 1;
  return c;
})();

const bedTypeEl      = document.getElementById("bedType") || _fallbackEl("select");
const presetBlock    = document.getElementById("presetBlock") || _fallbackEl();
const presetChips    = document.getElementById("presetChips") || _fallbackEl();
const customBlock    = document.getElementById("customBlock") || _fallbackEl();
const lenInput       = document.getElementById("lenInput") || _fallbackEl("input");
const widInput       = document.getElementById("widInput") || _fallbackEl("input");
const segBadges      = document.getElementById("segBadges") || _fallbackEl();

const desiredLenEl   = document.getElementById("desiredLen");
const desiredRangeEl = document.getElementById("desiredRange");
const desiredPriceEl = document.getElementById("desiredPrice");
const actionDesiredPriceEl = document.getElementById("actionDesiredPrice");

const sumType        = document.getElementById("sumType");
const sumDims        = document.getElementById("sumDims");
const sumSegs        = document.getElementById("sumSegs");
const sumMargin      = document.getElementById("sumMargin");
const sumFinal       = document.getElementById("sumFinal");
const sumRange       = document.getElementById("sumRange");
const sumBraidType   = document.getElementById("sumBraidType");
const sumFabric      = document.getElementById("sumFabric");
const sumColors      = document.getElementById("sumColors");

const resetBtn       = document.getElementById("resetBtn") || _fallbackEl("button");
const addBtn         = document.getElementById("addBtn") || _fallbackEl("button");
const addToCartButtons = [addBtn, mainAddBtn].filter(Boolean);

const canvasDims     = document.getElementById("canvasDims") || _fallbackEl("span");

const bedCanvas      = document.getElementById("bedCanvas") || _fallbackCanvas;
const bedCtx         = bedCanvas.getContext("2d");

/* =========================
   UI helpers
========================= */
function renderPresetChips(){
  presetChips.innerHTML = "";
  const list = PRESETS[bedState.bedType] || [];

  list.forEach((p, idx) => {
    const btn = document.createElement("button");
    btn.type = "button";
    btn.className = "chip" + (idx === bedState.presetIndex ? " active" : "");
    btn.textContent = `${p.l}×${p.L}`;
    btn.title = `Largeur ${p.l} cm, Longueur ${p.L} cm`;
    btn.addEventListener("click", () => {
      bedState.presetIndex = idx;
      bedState.L = p.L;
      bedState.l = p.l;
      syncInputsFromState();
      renderPresetChips();
      updateAll(); // ✅ met à jour tranche/variant, sans changer le visuel
    });
    presetChips.appendChild(btn);
  });
}

function toggleCustomMode(isCustom){
  presetBlock.style.display = isCustom ? "none" : "block";
  customBlock.style.display = isCustom ? "block" : "none";
}

function syncInputsFromState(){
  if(lenInput) lenInput.value = bedState.L;
  if(widInput) widInput.value = bedState.l;
  if(canvasDims) canvasDims.textContent = `${bedState.knownSizeCm ? Math.floor(Number(bedState.knownSizeCm)) + " cm" : "—"}`;
}

function renderSegBadges(){
  if(!segBadges) return;
  segBadges.innerHTML = "";
  const entries = [
    {key:"head", label:"Tête"},
    {key:"foot", label:"Pied"},
    {key:"left", label:"Côté gauche"},
    {key:"right",label:"Côté droit"},
  ];
  entries.forEach(e => {
    const span = document.createElement("span");
    span.className = "badge" + (bedState.segments[e.key] ? " on" : "");
    span.textContent = e.label;
    segBadges.appendChild(span);
  });
}

function syncInlineActionPrice(){
  if(!actionDesiredPriceEl) return;
  actionDesiredPriceEl.textContent = desiredPriceEl ? desiredPriceEl.textContent : "—";
}

function renderCalcAndSummary(){
  const { raw, rounded, range } = computeLengths();
  refreshMiniBraidOption();

  const isKnownSizeMode = bedState.mode === "known_size";

  let rangeText = "—";
  let pillClass = "pill warn";
  let canAdd = true;

  if(desiredLenEl) desiredLenEl.textContent = "—";
  if(desiredPriceEl) desiredPriceEl.textContent = "—";
  syncInlineActionPrice();
  if(desiredRangeEl){
    desiredRangeEl.textContent = "—";
    desiredRangeEl.className = "pill warn";
  }

  if(raw === 0){
    if(desiredLenEl) desiredLenEl.textContent = "—";
    rangeText = "Renseigne la longueur";
    pillClass = "pill warn";
    if(desiredPriceEl) desiredPriceEl.textContent = "—";
    syncInlineActionPrice();
    canAdd = false;

  } else if(range){
    if(desiredLenEl) desiredLenEl.textContent = `${rounded} cm`;
    rangeText = formatRange(range);
    pillClass = "pill ok";

    const variantId = resolveVariantIdFromRoundedLength(BRAID.type, rounded);
    if(!variantId){
      if(desiredPriceEl) desiredPriceEl.textContent = "—";
      syncInlineActionPrice();
      canAdd = false;
    }else{
      if(desiredPriceEl) desiredPriceEl.textContent = "…";
      syncInlineActionPrice();
      getVariantPrice(variantId).then(priceCents => {
        if(desiredPriceEl){
          const addonPriceCents = window.SISSOU_OPTION_CONFECTION?.getSelectedAddonPriceCents?.() || 0;
          const miniBraidPriceCents = getMiniBraidPriceCents();
          const totalPriceCents = priceCents != null ? priceCents + addonPriceCents + miniBraidPriceCents : null;

          desiredPriceEl.textContent = totalPriceCents != null ? formatMoneyCents(totalPriceCents) : "—";
          syncInlineActionPrice();
        }
      });
    }

  } else {
    if(desiredLenEl) desiredLenEl.textContent = `${rounded} cm`;
    rangeText = "Sur devis";
    pillClass = "pill danger";
    if(desiredPriceEl) desiredPriceEl.textContent = "—";
    syncInlineActionPrice();
    canAdd = false;
  }

  if(desiredRangeEl){
    desiredRangeEl.className = pillClass;
    desiredRangeEl.textContent = rangeText;
  }

  // Résumé lit / segments
  if(sumType) sumType.textContent = "Saisie manuelle";
  if(sumDims) sumDims.textContent = raw ? `Longueur saisie : ${raw} cm` : "Longueur non renseignée";

  const segs = getSelectedSegmentsList();
  if(sumSegs) sumSegs.textContent = "Personnalisation par longueur directe";

  if(sumMargin) sumMargin.textContent = "0 cm";

  // Longueur / plage
  if(sumFinal) sumFinal.textContent = raw ? `${rounded} cm` : "—";
  if(sumRange) sumRange.textContent = rangeText;

  // ✅ Tresse (certains ids ont été supprimés => safe)
  if(sumBraidType) sumBraidType.textContent = braidTypeLabel(BRAID.type);
  if(sumFabric)    sumFabric.textContent = (BRAID.currentFabricLabel || "—");
  if(sumColors)    sumColors.textContent = (BRAID.currentPaletteText || "—");

  addToCartButtons.forEach(btn => { btn.disabled = !canAdd; });

  syncInlineActionPrice();
  renderSegBadges();
}
/* =========================
   Canvas bed geometry + zones (FIXES)
   -> Ajuste UNE FOIS ces % pour coller à ta photo
========================= */
function getCanvasScaleRect(){
  // ✅ repère FIXE correspondant à l’intérieur du lit sur la photo
  const W = bedCanvas.width, H = bedCanvas.height;

  // 🔧 Ajuste ces valeurs si besoin (en % du canvas)
  const x = W * 0.08;
  const y = H * 0.12;
  const w = W * 0.84;
  const h = H * 0.76;

  return { x, y, w, h, s: 1 };
}

/**
 * ✅ Hit-test "photo"
 * - rails gauche/droite = rectForRails (outset)
 * - haut/bas = rect normal
 */
function hitTestSegmentPhoto(px, py, rect, rectForRails, edgePx){
  const leftX  = rectForRails.x;
  const rightX = rectForRails.x + rectForRails.w;

  const topY = rect.y;
  const botY = rect.y + rect.h;

  const onLeft  = Math.abs(px - leftX)  <= edgePx && py >= rect.y && py <= rect.y + rect.h;
  const onRight = Math.abs(px - rightX) <= edgePx && py >= rect.y && py <= rect.y + rect.h;
  const onTop   = Math.abs(py - topY)   <= edgePx && px >= rect.x && px <= rect.x + rect.w;
  const onBot   = Math.abs(py - botY)   <= edgePx && px >= rect.x && px <= rect.x + rect.w;

  if (onLeft)  return "left";
  if (onRight) return "right";
  if (onTop)   return "head";
  if (onBot)   return "foot";
  return null;
}

/**
 * ✅ Mapping physique -> logique
 * Photo: PIED à gauche, TÊTE à droite, haut= côté gauche, bas= côté droit
 */
function mapHitPhysicalToLogical(physical){
  if (physical === "left")  return "foot";  // gauche = PIED
  if (physical === "right") return "head";  // droite = TÊTE
  if (physical === "head")  return "left";  // haut = côté gauche
  if (physical === "foot")  return "right"; // bas = côté droit
  return null;
}

/* =========================
   Helpers draw text
========================= */
function drawLabelCentered(ctx, text, cx, cy){
  const metrics = ctx.measureText(text);
  ctx.fillText(text, cx - metrics.width/2, cy);
}
function drawLabelRot(ctx, text, cx, cy, rot){
  ctx.save();
  ctx.translate(cx, cy);
  ctx.rotate(rot);
  const metrics = ctx.measureText(text);
  ctx.fillText(text, -metrics.width/2, 0);
  ctx.restore();
}

/* =========================
   Tresse douce sur le lit
========================= */
function lerp(a, b, t){ return a + (b - a) * t; }

function getBraidColorsSoft(){
  const fallback = ["#eadbc8", "#f6f1eb", "#d8cfc4", "#c9c2ad", "#c8d2dd"];
  const out = [];
  for(let i=1; i<=BRAID.strandCount; i++){
    const hex = BRAID.currentColors?.[i]?.hex;
    out.push(hex || fallback[(i-1) % fallback.length]);
  }
  return out;
}

function drawBraidMulti(ctx, a, b, thickness, colors, alpha, strandCount, settings){
  if(alpha <= 0.001) return;

  const dx = b.x - a.x;
  const dy = b.y - a.y;
  const len = Math.hypot(dx, dy) || 1;

  const nx = -dy / len;
  const ny =  dx / len;

  const waves = Math.max(5, Math.min(10, Math.floor(len / 120)));
  const ampBase = Math.max(4, thickness * 0.18);
  const amp = ampBase * (settings.amplitudeMul || 1);

  // ombre
  ctx.save();
  ctx.globalAlpha = 0.16 * alpha;
  ctx.strokeStyle = "rgba(43,38,34,.55)";
  ctx.lineWidth = thickness + 10 * (settings.thicknessMul || 1);
  ctx.lineCap = "round";
  ctx.lineJoin = "round";
  ctx.filter = "blur(6px)";
  ctx.beginPath();
  for(let t=0; t<=1.0001; t+=0.05){
    const px = lerp(a.x, b.x, t);
    const py = lerp(a.y, b.y, t);
    ctx.lineTo(px + nx*3, py + ny*3);
  }
  ctx.stroke();
  ctx.restore();

  for(let i=0; i<strandCount; i++){
    const c = colors[i] || colors[colors.length-1] || "#eadbc8";
    const phase = (i * 2*Math.PI) / strandCount;

    const center = (strandCount - 1) / 2;
    const offset = (i - center) * (thickness * 0.16) * (settings.thicknessMul || 1);

    ctx.save();
    ctx.globalAlpha = 0.90 * alpha;
    ctx.strokeStyle = c;
    const wMul = (0.78 + i*0.04);
    ctx.lineWidth = thickness * wMul * (settings.thicknessMul || 1);
    ctx.lineCap = "round";
    ctx.lineJoin = "round";

    ctx.beginPath();
    for(let t=0; t<=1.0001; t+=0.045){
      const px = lerp(a.x, b.x, t);
      const py = lerp(a.y, b.y, t);
      const wv = Math.sin(t * Math.PI * waves * 2 + phase);
      ctx.lineTo(px + nx*(wv*amp + offset), py + ny*(wv*amp + offset));
    }
    ctx.stroke();

    // highlight
    ctx.globalAlpha = 0.16 * alpha * (settings.highlightMul || 1);
    ctx.strokeStyle = "rgba(255,255,255,.92)";
    ctx.lineWidth = Math.max(2, thickness * 0.18) * (settings.thicknessMul || 1);
    ctx.beginPath();
    for(let t=0; t<=1.0001; t+=0.07){
      const px = lerp(a.x, b.x, t);
      const py = lerp(a.y, b.y, t);
      const wv = Math.sin(t * Math.PI * waves * 2 + phase);
      ctx.lineTo(px + nx*(wv*amp*0.6 + offset), py + ny*(wv*amp*0.6 + offset));
    }
    ctx.stroke();

    ctx.restore();
  }
}

function drawBraidOnSegment(ctx, kind, rect, thickness, alpha, colors){
  const { x, y, w, h } = rect;
  const inset = thickness * 0.65;

  let a,b;
  if(kind === "head"){
    a = { x: x+inset, y: y };
    b = { x: x+w-inset, y: y };
  }else if(kind === "foot"){
    a = { x: x+inset, y: y+h };
    b = { x: x+w-inset, y: y+h };
  }else if(kind === "left"){
    a = { x: x, y: y+inset };
    b = { x: x, y: y+h-inset };
  }else{
    a = { x: x+w, y: y+inset };
    b = { x: x+w, y: y+h-inset };
  }

  const settings = getBraidSettings();
  drawBraidMulti(ctx, a, b, thickness, colors, alpha, BRAID.strandCount, settings);
}

/* =========================
   Lit photo + tresse
========================= */
// ✅ Background lit (photo) — chargé 1 seule fois
const bedBgImg = new Image();
bedBgImg.src = window.SISSOU_FILES?.["lit_background.png"] || "";
let bedBgReady = false;

bedBgImg.onload  = () => { bedBgReady = true; requestAnimationFrame(drawBed); };
bedBgImg.onerror = () => { bedBgReady = false; console.warn("Lit background introuvable: lit_background.png"); };

function drawBed(){
  const now = performance.now();
  const dt = (now - bedState.lastFrame) / 1000;
  bedState.lastFrame = now;

  const speed = 9;
  for(const k of Object.keys(bedState.anim)){
    const target = bedState.segments[k] ? 1 : 0;
    const a = bedState.anim[k];
    bedState.anim[k] = a + (target - a) * (1 - Math.exp(-speed * dt));
  }

  const rect = getCanvasScaleRect();

  bedCtx.clearRect(0,0,bedCanvas.width, bedCanvas.height);

  // 1) background photo
  if (bedBgReady) {
    bedCtx.drawImage(bedBgImg, 0, 0, bedCanvas.width, bedCanvas.height);
  } else {
    bedCtx.fillStyle = "#fff";
    bedCtx.fillRect(0,0,bedCanvas.width, bedCanvas.height);
  }

  // =========================================================
  // ✅ Calibration (tresse entre barreaux et matelas)
  // =========================================================
  const railOutsetX = rect.w * 0.10; // atteint les barreaux (extérieur)
  const railInsetX  = rect.w * 0.20; // rentre vers le matelas (~2-3cm visuel)
  const railInsetY  = rect.h * 0.01; // petit recentrage vertical

  const edgeInsetY  = rect.h * 0.08; // rentre haut/bas vers le matelas (~0.5cm visuel)
  const edgeInsetX  = rect.w * 0.06;  // léger recentrage horizontal haut/bas

  // 2) rect rails (gauche/droite) = entre barreaux et matelas
  const rectForRails = {
    x: rect.x - railOutsetX + railInsetX,
    y: rect.y + railInsetY,
    w: rect.w + railOutsetX * 2 - railInsetX * 2,
    h: rect.h - railInsetY * 2
  };

  // 3) rect edges (haut/bas) = légèrement rentré
  const rectForEdges = {
    x: rect.x + edgeInsetX,
    y: rect.y + edgeInsetY,
    w: rect.w - edgeInsetX * 2,
    h: rect.h - edgeInsetY * 2
  };

  // 4) tresse overlay
  const settings = getBraidSettings();
  const braidThickness =
    Math.max(16, Math.min(32, Math.min(rect.w, rect.h) * 0.075)) * (settings.thicknessMul || 1);
  const braidColors = getBraidColorsSoft();

  // ✅ TÊTE à droite / PIED à gauche (sur rails)
  drawBraidOnSegment(bedCtx, "right", rectForRails, braidThickness, bedState.anim.head, braidColors);
  drawBraidOnSegment(bedCtx, "left",  rectForRails, braidThickness, bedState.anim.foot, braidColors);

  // ✅ Haut = côté gauche / Bas = côté droit (sur edges)
  drawBraidOnSegment(bedCtx, "head", rectForEdges, braidThickness, bedState.anim.left,  braidColors);
  drawBraidOnSegment(bedCtx, "foot", rectForEdges, braidThickness, bedState.anim.right, braidColors);

  // 5) labels (calés rails + haut/bas)
  bedCtx.save();
  bedCtx.font = "900 15px ui-sans-serif, system-ui, -apple-system, Segoe UI, Roboto, Arial";
  bedCtx.fillStyle = "rgba(85, 83, 81, 0.99)";

  const padRails = rect.w * 0.13; // rentre TÊTE/PIED (~2-3cm visuel)
  const padEdges = rect.h * 0.05; // rentre haut/bas (~0.5cm visuel)

  const cy = rect.y + rect.h/2;

  drawLabelRot(bedCtx, "PIED", rectForRails.x - padRails, cy, -Math.PI/2);
  drawLabelRot(bedCtx, "TÊTE", rectForRails.x + rectForRails.w + padRails, cy,  Math.PI/2);

  drawLabelCentered(bedCtx, "CÔTÉ GAUCHE", rect.x + rect.w/2, rect.y - padEdges);
  drawLabelCentered(bedCtx, "CÔTÉ DROIT",  rect.x + rect.w/2, rect.y + rect.h + padEdges*2);

  bedCtx.restore();

  const moving = Object.values(bedState.anim).some(a => a > 0.001 && a < 0.999);
  if(moving) requestAnimationFrame(drawBed);
}

/* =========================
   Update / events bed
========================= */
function updateAll(){
  safeDims();
  syncInputsFromState();
  renderCalcAndSummary();
  if(presetChips) renderPresetChips();
  if(bedCanvas) requestAnimationFrame(drawBed);
}

function validateKnownSize(value){
  const raw = String(value ?? "").trim();
  const maxAllowed = BRAID.type === "3xxl" ? 480 : 660;

  if(!raw){
    return { valid:false, message:`Renseigne une longueur entre 30 cm et ${maxAllowed} cm.`, normalized:null, rounded:null };
  }

  const num = Number(raw.replace(',', '.'));
  if(!Number.isFinite(num) || !Number.isInteger(num)){
    return { valid:false, message:"Entre un nombre entier en centimètres.", normalized:null, rounded:null };
  }

  if(num < 30 || num > maxAllowed){
    const maxMsg = BRAID.type === "3xxl" ? "La tresse 3 brins XXL ne peut pas dépasser 480 cm." : `La longueur doit être comprise entre 30 cm et ${maxAllowed} cm.`;
    return { valid:false, message:maxMsg, normalized:num, rounded:null };
  }

  const rounded = roundDown10(num);
  if(rounded < 30){
    return { valid:false, message:"La longueur arrondie doit rester au minimum à 30 cm.", normalized:num, rounded };
  }

  return { valid:true, message:`Longueur retenue : ${rounded} cm.`, normalized:num, rounded };
}

function refreshKnownSizeEntry(){
  if(!knownTresseSizeInput || !knownTresseSizeError) return { valid:false };

  const result = validateKnownSize(knownTresseSizeInput.value);
  knownTresseSizeInput.classList.toggle("is-invalid", !!knownTresseSizeInput.value && !result.valid);
  knownTresseSizeError.textContent = result.message || "";
  knownTresseSizeError.style.color = result.valid ? "var(--ok)" : "var(--danger)";

  bedState.mode = "known_size";
  bedState.knownSizeCm = result.valid ? result.normalized : null;

  if(knownTresseSizeContinue) knownTresseSizeContinue.disabled = !result.valid;
  return result;
}

function startKnownSizeFlow(){ return refreshKnownSizeEntry(); }

function goBackToTresseEntry(){ return false; }

if(bedTypeEl) bedTypeEl.addEventListener("change", () => {
  bedState.bedType = bedTypeEl.value;
  const isCustom = bedState.bedType === "Personnalisé";
  toggleCustomMode(isCustom);

  if(!isCustom){
    const list = PRESETS[bedState.bedType] || [];
    bedState.presetIndex = 0;
    if(list[0]){
      bedState.L = list[0].L;
      bedState.l = list[0].l;
    }
    renderPresetChips();
  }
  updateAll();
});

if(lenInput) lenInput.addEventListener("input", () => { bedState.L = Number(lenInput.value); updateAll(); });
if(widInput) widInput.addEventListener("input", () => { bedState.l = Number(widInput.value); updateAll(); });

if(bedCanvas) bedCanvas.addEventListener("click", (ev) => {
  if(bedState.mode === "known_size") return;
  const domRect = bedCanvas.getBoundingClientRect();
  const px = (ev.clientX - domRect.left) * (bedCanvas.width / domRect.width);
  const py = (ev.clientY - domRect.top)  * (bedCanvas.height / domRect.height);

  const rect = getCanvasScaleRect();

  // ✅ doit matcher drawBed()
  const railOutsetX = rect.w * 0.10;
  const railInsetX  = rect.w * 0.20;
  const railInsetY  = rect.h * 0.01;

  const edgeInsetY  = rect.h * 0.08;
  const edgeInsetX  = rect.w * 0.06;

  const rectForRails = {
    x: rect.x - railOutsetX + railInsetX,
    y: rect.y + railInsetY,
    w: rect.w + railOutsetX * 2 - railInsetX * 2,
    h: rect.h - railInsetY * 2
  };

  const rectForEdges = {
    x: rect.x + edgeInsetX,
    y: rect.y + edgeInsetY,
    w: rect.w - edgeInsetX * 2,
    h: rect.h - edgeInsetY * 2
  };

  const edgePx = Math.max(22, rect.w * 0.03);

  // ✅ hit test: rails pour gauche/droite, edges pour haut/bas
  const hitPhysical = hitTestSegmentPhoto(px, py, rectForEdges, rectForRails, edgePx);
  if(!hitPhysical) return;

  const hitLogical = mapHitPhysicalToLogical(hitPhysical);
  if(!hitLogical) return;

  bedState.segments[hitLogical] = !bedState.segments[hitLogical];

  requestAnimationFrame(drawBed);
  updateAll();
});

if(bedCanvas) bedCanvas.addEventListener("mousemove", (ev) => {
  if(bedState.mode === "known_size"){
    bedCanvas.style.cursor = "default";
    return;
  }
  const domRect = bedCanvas.getBoundingClientRect();
  const px = (ev.clientX - domRect.left) * (bedCanvas.width / domRect.width);
  const py = (ev.clientY - domRect.top)  * (bedCanvas.height / domRect.height);

  const rect = getCanvasScaleRect();

  const railOutsetX = rect.w * 0.10;
  const railInsetX  = rect.w * 0.20;
  const railInsetY  = rect.h * 0.01;

  const edgeInsetY  = rect.h * 0.08;
  const edgeInsetX  = rect.w * 0.06;

  const rectForRails = {
    x: rect.x - railOutsetX + railInsetX,
    y: rect.y + railInsetY,
    w: rect.w + railOutsetX * 2 - railInsetX * 2,
    h: rect.h - railInsetY * 2
  };

  const rectForEdges = {
    x: rect.x + edgeInsetX,
    y: rect.y + edgeInsetY,
    w: rect.w - edgeInsetX * 2,
    h: rect.h - edgeInsetY * 2
  };

  const edgePx = Math.max(22, rect.w * 0.03);

  const hitPhysical = hitTestSegmentPhoto(px, py, rectForEdges, rectForRails, edgePx);
  const hitLogical  = hitPhysical ? mapHitPhysicalToLogical(hitPhysical) : null;

  bedCanvas.style.cursor = hitLogical ? "pointer" : "default";
});



/* =========================
   Add to cart
========================= */
async function addToCartItems(items){
  const cartDrawer = document.querySelector('cart-drawer');

  const payload = {
    items
  };

  if(cartDrawer && typeof cartDrawer.getSectionsToRender === 'function'){
    payload.sections = cartDrawer.getSectionsToRender().map(section => section.id);
    payload.sections_url = window.location.pathname;
  }else{
    payload.sections = ['cart-drawer', 'cart-icon-bubble'];
    payload.sections_url = window.location.pathname;
  }

  const res = await fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    },
    body: JSON.stringify(payload)
  });

  if(!res.ok){
    const txt = await res.text();
    throw new Error(txt || "Erreur ajout panier");
  }

  return await res.json();
}

async function addToCart(variantId, properties){
  return addToCartItems([
    {
      id: variantId,
      quantity: 1,
      properties
    }
  ]);
}


async function handleAddToCart(){
  const validation = refreshKnownSizeEntry();
  if(!validation.valid) return;

  const { raw, rounded, range } = computeLengths();
  if(raw === 0 || !range) return;

  const variantId = resolveVariantIdFromRoundedLength(BRAID.type, rounded);
  if(!variantId){
    alert(`Aucune variante trouvée pour ${braidTypeLabel(BRAID.type)} (longueur ${rounded} cm).`);
    return;
  }

const miniInfo = getMiniBraidInfo();
const wantsMiniBraid = isMiniBraidSelected() && miniInfo;

const properties = {
  "Longueur souhaitée (cm)": String(rounded),
  "Type de tresse": braidTypeLabel(BRAID.type),
  "Détails brins": (BRAID.currentPaletteText || "—"),
  "Mini tresse identique": wantsMiniBraid ? `${miniInfo.title} - ${formatMoneyCents(miniInfo.priceCents)}` : "Non"
};

const cartItems = [
  {
    id: variantId,
    quantity: 1,
    properties
  }
];

if(wantsMiniBraid){
  cartItems.push({
    id: miniInfo.variantId,
    quantity: 1,
    properties: {
      "_bundle_role": "mini",
      "_mini_tresse_associee": miniInfo.title,
      "_type_tresse_principale": braidTypeLabel(BRAID.type),
      "_couleurs_identiques": "Oui"
    }
  });
}

try{
  addToCartButtons.forEach(btn => { btn.disabled = true; });
  const parsedState = await addToCartItems(cartItems);

  const cartDrawer = document.querySelector('cart-drawer');

  if(
    cartDrawer &&
    parsedState &&
    parsedState.sections &&
    typeof cartDrawer.renderContents === 'function'
  ){
    cartDrawer.classList.remove('is-empty');
    cartDrawer.renderContents(parsedState);
  }else{
    window.location.href = "/cart";
  }
  }catch(err){
    console.error(err);
    alert("Erreur lors de l'ajout au panier. Ouvre la console (F12) pour voir le détail.");
  }finally{
    renderCalcAndSummary();
  }
}

addToCartButtons.forEach(btn => {
  btn.addEventListener("click", handleAddToCart);
});

if(knownTresseSizeInput){
  const syncKnownSize = () => { refreshKnownSizeEntry(); updateAll(); };
  knownTresseSizeInput.addEventListener("input", syncKnownSize);
  knownTresseSizeInput.addEventListener("blur", syncKnownSize);
}

if(knownTresseSizeContinue){
  knownTresseSizeContinue.addEventListener("click", startKnownSizeFlow);
}

if(knownSizeBackBtn){
  knownSizeBackBtn.addEventListener("click", goBackToTresseEntry);
}

function closeHelpPresets(){
  if(!needHelpTresseMsg) return;
  needHelpTresseMsg.classList.remove('is-open');
  needHelpTresseBtn?.setAttribute('aria-expanded', 'false');
}

function openHelpPresets(){
  if(!needHelpTresseMsg) return;
  buildHelpPresetsPanel();
  needHelpTresseMsg.classList.add('is-open');
  needHelpTresseBtn?.setAttribute('aria-expanded', 'true');
}

function toggleHelpPresets(){
  if(!needHelpTresseMsg) return;
  if(needHelpTresseMsg.classList.contains('is-open')) closeHelpPresets();
  else openHelpPresets();
}

function applyPresetLength(value, label){
  if(!knownTresseSizeInput) return;
  knownTresseSizeInput.value = String(value);
  refreshKnownSizeEntry();
  updateAll();
  knownTresseSizeInput.focus();
  knownTresseSizeInput.scrollIntoView({ behavior: 'smooth', block: 'center' });

  if(needHelpTresseMsg){
    needHelpTresseMsg.querySelectorAll('[data-help-length]').forEach(btn => {
      btn.classList.toggle('is-selected', Number(btn.dataset.helpLength) === Number(value));
    });
  }

  window.setTimeout(() => {
    closeHelpPresets();
  }, 180);
}

function buildHelpPresetsPanel(){
  if(!needHelpTresseMsg || helpPresetsBuilt) return;

  const cards = HELP_PRESETS.map(group => {
    const buttons = group.items.map(item => `
      <button type="button" class="help-length-chip" data-help-length="${item.value}">
        <span class="help-length-chip-label">${item.label}</span>
        <span class="help-length-chip-value">${item.value} cm</span>
      </button>
    `).join('');

    return `
      <section class="help-size-card">
        <div class="help-size-card-title">${group.title}</div>
        <div class="help-size-card-grid">${buttons}</div>
      </section>
    `;
  }).join('');

  const heights = HELP_HEIGHTS.map(item => `<span class="help-height-chip">${item}</span>`).join('');

  needHelpTresseMsg.innerHTML = `
    <div class="help-presets-panel">
      <div class="help-presets-intro">Sélectionnez une longueur standard pour préremplir directement le champ du configurateur.</div>
      <div class="help-size-grid">${cards}</div>
      <div class="help-heights">
        <div class="help-heights-title">Hauteurs moyennes</div>
        <div class="help-heights-list">${heights}</div>
      </div>
    </div>
  `;

  needHelpTresseMsg.addEventListener('click', (e) => {
    const chip = e.target.closest('[data-help-length]');
    if(!chip) return;
    const value = Number(chip.dataset.helpLength);
    if(!value) return;
    applyPresetLength(value, chip.textContent.trim());
  });

  helpPresetsBuilt = true;
}

if(needHelpTresseBtn){
  needHelpTresseBtn.setAttribute('aria-expanded', 'false');
  needHelpTresseBtn.addEventListener('click', () => {
    toggleHelpPresets();
  });
}

if(miniBraidCheckbox){
  miniBraidCheckbox.addEventListener("change", () => {
    renderCalcAndSummary();
  });
}

if(scrollPourInfoBtn){
  scrollPourInfoBtn.addEventListener("click", scrollToPourInfo);
}

refreshKnownSizeEntry();
updateAll();

document.addEventListener("sissou:addon-selection-changed", () => {
  renderCalcAndSummary();
});

window.addEventListener("resize", () => { if(bedCanvas) requestAnimationFrame(drawBed); });

/******************************************************************
 * PART B — Personnalisation tresse
 * ✅ doudou / nid_abeille / cotele : couleurs
 * ✅ lisse_synthetique : motifs (38) depuis des JPG dédiés
 ******************************************************************/

/** Tissus */
const FABRIC_LABELS = {
  doudou: "Doudou",
  nid_abeille: "Nid d’abeille",
  cotele: "Côtelé",
  lisse_synthetique: "Motifs"
};
const FABRICS_WITH_MOTIFS = new Set(["lisse_synthetique"]);
const isMotifFabric = (fabricKey) => FABRICS_WITH_MOTIFS.has(fabricKey);

/** ✅ Réglage taille motif */
const MOTIF_SCALE = 0.70; // utilisé uniquement pour le rendu tuilé de secours

/**
 * Rendu direct du JPG motif sur le brin.
 * Plus la valeur est proche de 1, plus on affiche une grande partie du visuel source
 * donc moins le motif paraît zoomé.
 */
const MOTIF_DIRECT_CROP = 0.94;

/** Palettes couleurs (3 tissus)*/
const PALETTES = {
  doudou: [
    { name:"Blanc", hex:"#ffffff" }, { name:"Écru", hex:"#ede6deff" }, { name:"Vanille", hex:"#fdf1d8" },
    { name:"Beige", hex:"#f0d5ad" }, { name:"Galet", hex:"#7e5e50ff" }, { name:"Marron", hex:"#56392aff" },
    { name:"Camel", hex:"#b77c3dff" }, { name:"Moutarde", hex:"#a4610aff" }, { name:"Terracotta", hex:"#711003" },
    { name:"Prune", hex:"#714e6f" }, { name:"Fuchsia", hex:"#c52f5c" }, { name:"Vieux rose", hex:"#8e4353" },
    { name:"Poudré", hex:"#b77785ff" }, { name:"Rose", hex:"#f7c4e5" }, { name:"Lavande", hex:"#b3a2bb" },
    { name:"Anthracite", hex:"#4f5665ff" }, { name:"Gris", hex:"#c4c4c4ff" }, { name:"Menthe", hex:"#97c6aaff" },
    { name:"Jade", hex:"#849064ff" }, { name:"Olive", hex:"#505945ff" }, { name:"Pétrole", hex:"#205162" },
    { name:"Bleu", hex:"#6588c4" }, { name:"Chocolat", hex:"#321b10ff" }, { name:"Bordeaux", hex:"#550314" },
    { name:"Foret", hex:"#0b2e0e" }, { name:"Roi", hex:"#253b7c" },
  ],
  nid_abeille: [
    { name:"Blanc", hex:"#ffffff" }, { name:"Écru", hex:"#fffcf8" }, { name:"Beige", hex:"#c6aa8f" },
    { name:"Café", hex:"#6d5346" }, { name:"Marine", hex:"#040923" }, { name:"Roi", hex:"#26467dff" },
    { name:"Jean", hex:"#6085aeff" }, { name:"Poussin", hex:"#e7c566ff" }, { name:"Moutarde", hex:"rgba(200, 162, 37, 1)" },
    { name:"Camel", hex:"#956131ff" }, { name:"Brique", hex:"#942c00ff" }, { name:"Bleu", hex:"#d0e3f0ff" },
    { name:"Céladon", hex:"#576f77ff" }, { name:"Vert d'eau", hex:"#b3d3c0" }, { name:"Marsala", hex:"#a72f22ff" },
    { name:"Vieux rose", hex:"#8e4353" }, { name:"Poudré", hex:"#cd9aa5ff" }, { name:"Corail", hex:"#b55a56ff" },
    { name:"Rose", hex:"#f7c4e5" }, { name:"Lavande", hex:"#a78cb3ff" }, { name:"Gris", hex:"#cbcbcb" },
    { name:"Anthracite", hex:"#424242" }, { name:"Sauge", hex:"#8f9974" }, { name:"Olive", hex:"rgba(101, 111, 95, 1)" },//*#6e7952*/
    { name:"Kaki", hex:"#131900" }, { name:"Chocolat", hex:"#250c03" }, { name:"Safran", hex:"#70391a" }, 
    { name:"Rose pale", hex:"#fbdce7ff" }, { name:"Melon", hex:"#f9b371ff" }, { name:"Souris", hex:"#7a7884" }, { name:"Bleu moyen", hex:"#9ec9f1ff" }
  ],
  cotele: [
    { name:"Blanc", hex:"#ffffff" }, { name:"Écru", hex:"#fffcf8" },{ name:"Crème", hex:"#ebd9b9" }, 
    { name:"Beige Claire", hex:"#dac3a7ff" },{ name:"Beige Foncé", hex:"#b19f85ff" }, { name:"Galet", hex:"#695249ff" },    
    { name:"Camel", hex:"#936c45ff" }, { name:"Marron", hex:"#2c1507" }, { name:"Menthe", hex:"#b3d3c0" }, { name:"Olive", hex:"#5d5c49" },
    { name:"Vieux Rose", hex:"#ae5064ff" }, { name:"Poudré", hex:"#b293a1" }, { name:"Marine", hex:"#2b3048" },{ name:"Violet", hex:"#4d315a" },
    
    

  ],
};
function getPalette(fabricKey){ return PALETTES[fabricKey] || PALETTES.doudou; }

/******************************************************************
 * MOTIFS (38)
 ******************************************************************/
const MOTIFS = [
  { id: 1,  name: "Printemps" },
  { id: 2,  name: "Fleurs d hiver" },
  { id: 3,  name: "Prairie" },
  { id: 4,  name: "Fleurs des champs" },
  { id: 6,  name: "Petit coeur rose" },
  { id: 7,  name: "Fleurs de lin" },
  { id: 8,  name: "Hortense" },
  { id: 9,  name: "Fleurs d été" },
  { id: 10, name: "Vichy rose" },
  { id: 11, name: "Fleures plaquettes" },
  { id: 12, name: "Zada" },
  { id: 13, name: "Coeurs" },
  { id: 14, name: "Birdy" },
  { id: 15, name: "Fleurs fushia" },
  { id: 16, name: "Fleurs pastel" },
  { id: 17, name: "Luana" },
  { id: 18, name: "Eucalyptus" },
  { id: 19, name: "Leopard" },
  { id: 20, name: "Zebre" },
  { id: 21, name: "Forêt" },
  { id: 22, name: "Biche" },
  { id: 23, name: "Avion" },
  { id: 24, name: "Arc en ciel" },
  { id: 25, name: "Hippocampe" },
  { id: 26, name: "Dragons" },
  { id: 27, name: "Jungo" },
  { id: 28, name: "Broceliande" },
  { id: 29, name: "Bambi" },
  { id: 30, name: "Elephant olive" },
  { id: 31, name: "Croco" },
  { id: 32, name: "Lion" },
  { id: 33, name: "Girafe bleu" },
  { id: 35, name: "Fusée" },
  { id: 36, name: "Cigogne" },
  { id: 34, name: "Vichy beige" },
  { id: 37, name: "Vichy vert" },
  { id: 38, name: "Vichy bleu" },
  { id: 39, name: "Fleur peche" },
  { id: 40, name: "Old Flowers" },
  {id: 41, name: "Safari" },
  {id: 42, name: "Souricette" },
  {id: 43, name: "Paquerette" },
  { id: 44, name: "Wildflower" },
  { id: 45, name: "Marguerite" },
  { id: 46, name: "Fleursetoilees" },
  { id: 47, name: "Doudouleopard" },
  { id: 48, name: "Doudouutopia" },
  { id: 49, name: "Fleurscerisier" },
  { id: 50, name: "Branchesbleues" },
  { id: 51, name: "Animauxrayures" },
  { id: 52, name: "Petunia" },
  { id: 53, name: "Mimosa" },
  { id: 54, name: "Fleurs Pâles" },
  { id: 55, name: "Licorne" },
];

const motifById = (id) => MOTIFS.find(m => m.id === Number(id));

/******************************************************************
 * Fichiers motifs JPG
 ******************************************************************/
function fileUrl(filename){
  return (window.SISSOU_FILES && window.SISSOU_FILES[filename]) ? window.SISSOU_FILES[filename] : filename;
}

const motifImgCache = {};
function getMotifImgByFilename(filename){
  if(!filename) return null;
  const url = fileUrl(filename);
  if(motifImgCache[url]) return motifImgCache[url];
  const img = new Image();
  img.decoding = "async";
  img.src = url;
  img.onload = () => renderAllStrands();
  img.onerror = () => {
    console.warn("Motif introuvable :", url);
    renderAllStrands();
  };
  motifImgCache[url] = img;
  return img;
}

/******************************************************************
 * Motif tile (canvas) — ✅ JPG dédiés + crop central + anti-bords
 ******************************************************************/
const motifTileCache = {};

function featherTileEdges(ctx, x, y, w, h, feather){
  if(feather <= 0) return;

  ctx.save();
  ctx.globalCompositeOperation = "destination-in";

  let g = ctx.createLinearGradient(x, y, x + feather, y);
  g.addColorStop(0, "rgba(0,0,0,0)");
  g.addColorStop(1, "rgba(0,0,0,1)");
  ctx.fillStyle = g;
  ctx.fillRect(x, y, feather, h);

  g = ctx.createLinearGradient(x + w - feather, y, x + w, y);
  g.addColorStop(0, "rgba(0,0,0,1)");
  g.addColorStop(1, "rgba(0,0,0,0)");
  ctx.fillStyle = g;
  ctx.fillRect(x + w - feather, y, feather, h);

  g = ctx.createLinearGradient(x, y, x, y + feather);
  g.addColorStop(0, "rgba(0,0,0,0)");
  g.addColorStop(1, "rgba(0,0,0,1)");
  ctx.fillStyle = g;
  ctx.fillRect(x, y, w, feather);

  g = ctx.createLinearGradient(x, y + h - feather, x, y + h);
  g.addColorStop(0, "rgba(0,0,0,1)");
  g.addColorStop(1, "rgba(0,0,0,0)");
  ctx.fillStyle = g;
  ctx.fillRect(x, y + h - feather, w, feather);

  ctx.restore();
}

function buildMotifCoreTileFromImage(img, cropSize, sx, sy, TILE){
  const core = document.createElement("canvas");
  core.width = TILE;
  core.height = TILE;
  const c = core.getContext("2d");
  c.imageSmoothingEnabled = true;
  c.imageSmoothingQuality = "high";
  c.clearRect(0, 0, TILE, TILE);
  c.drawImage(img, sx, sy, cropSize, cropSize, 0, 0, TILE, TILE);

  // léger adoucissement pour éviter un rendu trop dur sans casser le motif
  c.save();
  c.globalAlpha = 0.12;
  c.filter = "blur(3px)";
  c.drawImage(core, 0, 0);
  c.restore();

  return core;
}

function buildBleededTile(coreTile, bleed){
  const TILE = coreTile.width;
  const tile = document.createElement("canvas");
  tile.width = TILE + bleed * 2;
  tile.height = TILE + bleed * 2;

  const ctx = tile.getContext("2d");
  ctx.imageSmoothingEnabled = true;
  ctx.imageSmoothingQuality = "high";
  ctx.clearRect(0, 0, tile.width, tile.height);

  // centre
  ctx.drawImage(coreTile, bleed, bleed, TILE, TILE);

  // bords étendus depuis la tuile centrale
  ctx.drawImage(coreTile, 0, 0, TILE, 1, bleed, 0, TILE, bleed);                 // top
  ctx.drawImage(coreTile, 0, TILE - 1, TILE, 1, bleed, bleed + TILE, TILE, bleed); // bottom
  ctx.drawImage(coreTile, 0, 0, 1, TILE, 0, bleed, bleed, TILE);                 // left
  ctx.drawImage(coreTile, TILE - 1, 0, 1, TILE, bleed + TILE, bleed, bleed, TILE); // right

  // coins
  ctx.drawImage(coreTile, 0, 0, 1, 1, 0, 0, bleed, bleed);
  ctx.drawImage(coreTile, TILE - 1, 0, 1, 1, bleed + TILE, 0, bleed, bleed);
  ctx.drawImage(coreTile, 0, TILE - 1, 1, 1, 0, bleed + TILE, bleed, bleed);
  ctx.drawImage(coreTile, TILE - 1, TILE - 1, 1, 1, bleed + TILE, bleed + TILE, bleed, bleed);

  featherTileEdges(ctx, bleed, bleed, TILE, TILE, Math.max(10, Math.round(TILE * 0.04)));
  return tile;
}

function getMotifTileCanvas(motifId){
  const m = motifById(motifId);
  if(!m) return null;

  const filename = getMotifFileFor(m.name);
  if(!filename) return null;

  const key = `${motifId}:${filename}`;
  if(motifTileCache[key]) return motifTileCache[key];

  const img = getMotifImgByFilename(filename);
  if(!img) return null;

  if(!img.complete || img.naturalWidth <= 0 || img.naturalHeight <= 0) return null;

  const shortest = Math.min(img.naturalWidth, img.naturalHeight);
  const cropSize = Math.max(96, Math.round(shortest * 0.62));
  const sx = Math.max(0, Math.round((img.naturalWidth - cropSize) / 2));
  const sy = Math.max(0, Math.round((img.naturalHeight - cropSize) / 2));

  const TILE = 420;
  const BLEED = 20;
  const core = buildMotifCoreTileFromImage(img, cropSize, sx, sy, TILE);
  const tile = buildBleededTile(core, BLEED);

  motifTileCache[key] = tile;
  return tile;
}

function applyMotifImageDirectToBaseMask(ctx, baseImg, motifImg, zoom=1.0){
  if(!motifImg || !motifImg.complete || motifImg.naturalWidth === 0 || motifImg.naturalHeight === 0){
    applyMotifToBaseMask(ctx, baseImg, null, zoom);
    return;
  }

  const w = ctx.canvas.width;
  const h = ctx.canvas.height;
  ctx.clearRect(0,0,w,h);
  ctx.imageSmoothingEnabled = true;
  ctx.imageSmoothingQuality = "high";

  const iw = motifImg.naturalWidth;
  const ih = motifImg.naturalHeight;

  // On repart sur un rendu zoomé, mais recalculé à partir de l'image entière.
  // Le motif est mis à l'échelle sans étirer les extrémités, puis répété en alternance
  // miroir pour éviter un raccord brutal visible au milieu des brins.
  const safeZoom = Math.max(0.72, Math.min(1.18, Number(zoom) || 1));
  const targetTileH = Math.max(h * 1.08, h * safeZoom);
  const scale = targetTileH / ih;
  const tileW = Math.max(1, Math.round(iw * scale));
  const tileH = Math.max(1, Math.round(ih * scale));
  const y = Math.round((h - tileH) / 2);

  const overlap = Math.max(10, Math.round(Math.min(w, h) * 0.06));
  const step = Math.max(1, tileW - overlap);
  const startX = -Math.round(tileW * 0.28);

  let index = 0;
  for(let x = startX; x < w + tileW; x += step){
    ctx.save();
    if(index % 2 === 1){
      ctx.translate(x + tileW, y);
      ctx.scale(-1, 1);
      ctx.drawImage(motifImg, 0, 0, tileW, tileH);
    }else{
      ctx.drawImage(motifImg, x, y, tileW, tileH);
    }
    ctx.restore();
    index++;
  }

  // fondu léger sur les zones de raccord pour éviter un joint sec
  ctx.save();
  ctx.globalCompositeOperation = "soft-light";
  ctx.globalAlpha = 0.08;
  for(let x = startX + step; x < w; x += step){
    const g = ctx.createLinearGradient(x - overlap, 0, x + overlap, 0);
    g.addColorStop(0, "rgba(255,255,255,0)");
    g.addColorStop(0.5, "rgba(255,255,255,1)");
    g.addColorStop(1, "rgba(255,255,255,0)");
    ctx.fillStyle = g;
    ctx.fillRect(x - overlap, 0, overlap * 2, h);
  }
  ctx.restore();

  ctx.globalCompositeOperation = "destination-in";
  ctx.drawImage(baseImg, 0, 0, w, h);
  ctx.globalCompositeOperation = "source-over";

  ctx.save();
  ctx.globalAlpha = 0.18;
  ctx.drawImage(baseImg, 0, 0, w, h);
  ctx.restore();

  ctx.globalCompositeOperation = "multiply";
  ctx.globalAlpha = 0.58;
  ctx.drawImage(baseImg, 0, 0, w, h);

  ctx.globalCompositeOperation = "overlay";
  ctx.globalAlpha = 0.18;
  ctx.drawImage(baseImg, 0, 0, w, h);

  ctx.globalCompositeOperation = "screen";
  ctx.globalAlpha = 0.05;
  ctx.fillStyle = "#ffffff";
  ctx.fillRect(0,0,w,h);

  ctx.globalCompositeOperation = "destination-in";
  ctx.globalAlpha = 1;
  ctx.drawImage(baseImg, 0, 0, w, h);

  ctx.globalCompositeOperation = "source-over";
  ctx.globalAlpha = 1;
}

function drawMotifImageCover(ctx, img, w, h){
  if(!img || !img.complete || img.naturalWidth === 0 || img.naturalHeight === 0) return false;

  const srcRatio = img.naturalWidth / img.naturalHeight;
  const dstRatio = w / h;
  let sx = 0, sy = 0, sw = img.naturalWidth, sh = img.naturalHeight;

  if(srcRatio > dstRatio){
    sw = Math.round(img.naturalHeight * dstRatio);
    sx = Math.round((img.naturalWidth - sw) / 2);
  }else{
    sh = Math.round(img.naturalWidth / dstRatio);
    sy = Math.round((img.naturalHeight - sh) / 2);
  }

  ctx.drawImage(img, sx, sy, sw, sh, 0, 0, w, h);
  return true;
}
/******************************************************************
 * DOM (tresse)
 ******************************************************************/
const braidPreviewTitle = document.getElementById("braidPreviewTitle");
const previewBraidTypeEl = document.getElementById("preview-braid-type");

// ✅ ceux-ci peuvent ne plus exister
const previewColors = document.getElementById("preview-colors");   // peut être null
const previewFabric = document.getElementById("preview-fabric");   // peut être null

const summaryText = document.getElementById("summary-text");

const assetWarn  = document.getElementById("assetWarn");
const strandRows = document.getElementById("strandRows");

const finalCanvas    = document.getElementById("canvas-braid");
const braidTypeChips = document.getElementById("braidTypeChips");

let strandCanvasMap = {};
let offscreenMap = {};

/******************************************************************
 * Base PNG (masques brins) — MAJ : lisse_synthetique => PNG dédiés
 ******************************************************************/
function normalizeFabricForFilename(fabricKey){
  if(fabricKey === "nid_abeille") return "nidabeille";
  if(fabricKey === "lisse_synthetique") return "doudou";
  return fabricKey;
}

function baseImagePathFor(strandIndex, fabricKey){

  if(FORCE_MASTER_GEOMETRY_FOR_5BRINS && BRAID.type === "5"){
    fabricKey = "doudou";
  }

  const fk = normalizeFabricForFilename(fabricKey);

  const prefix =
    (BRAID.type === "4")    ? "4brins" :
    (BRAID.type === "5")    ? "5brins" :
    (BRAID.type === "3xxl") ? "3xxlbrins" :
                              "3brins";

  const filename = `${prefix}${fk}${strandIndex}.png`;
  return fileUrl(filename);
}

const baseImgCache = {};
function getBaseImg(path){
  if(baseImgCache[path]) return baseImgCache[path];
  const img = new Image();
  img.src = path;
  img.onload = () => renderAllStrands();
  img.onerror = () => { console.warn("Base PNG introuvable :", path); renderAllStrands(); };
  baseImgCache[path] = img;
  return img;
}

function ensureStrandCanvases(){
  strandCanvasMap = {};
  offscreenMap = {};
  for(let i=1; i<=BRAID.strandCount; i++){
    strandCanvasMap[i] = document.createElement("canvas");
    offscreenMap[i] = document.createElement("canvas");
  }
}

function resizeFinalToFirstAvailable(){
  const ref = getBaseImg(baseImagePathFor(1, "doudou"));
  if(!ref.complete || ref.naturalWidth === 0) return;

  const w = ref.naturalWidth;
  const h = ref.naturalHeight;

  finalCanvas.width = w;
  finalCanvas.height = h;

  Object.values(strandCanvasMap).forEach(c => { c.width = w; c.height = h; });
  Object.values(offscreenMap).forEach(c => { c.width = w; c.height = h; });
}

function resolveBaseImage(strandIndex){
  const fabricKey = BRAID.currentFabrics[strandIndex] || "doudou";
  const usedFabric = isMotifFabric(fabricKey) ? "lisse_synthetique" : fabricKey;

  const wanted = baseImagePathFor(strandIndex, usedFabric);
  const img = getBaseImg(wanted);

  if(img.complete && img.naturalWidth === 0){
    return getBaseImg(baseImagePathFor(strandIndex, "doudou"));
  }
  return img;
}

function checkAssets(){
  const missing = [];
  let needsWarn = false;

  for(let i=1; i<=BRAID.strandCount; i++){
    const fabricKey = BRAID.currentFabrics[i] || "doudou";
    const usedFabric = isMotifFabric(fabricKey) ? "lisse_synthetique" : fabricKey;

    const wantedPath = baseImagePathFor(i, usedFabric);
    const img = getBaseImg(wantedPath);

    if(img.complete && img.naturalWidth === 0){
      needsWarn = true;
      missing.push(wantedPath);
    }
  }

  BRAID.missingAssets = missing;
  BRAID.previewEnabled = true;
  assetWarn.classList.toggle("show", needsWarn);

  if(needsWarn){
    assetWarn.innerHTML = `⚠️ Certains assets tissu manquent.<br/>Fallback automatique sur Doudou si nécessaire.`;
  }
}

/******************************************************************
 * Tint couleur (inchangé)
 ******************************************************************/
function tintBaseImage(ctx, baseImg, hex){
  const w = ctx.canvas.width;
  const h = ctx.canvas.height;

  ctx.clearRect(0,0,w,h);

  ctx.globalCompositeOperation = "source-over";
  ctx.globalAlpha = 1;
  ctx.drawImage(baseImg, 0, 0, w, h);

  ctx.globalCompositeOperation = "multiply";
  ctx.globalAlpha = 0.78;
  ctx.fillStyle = hex;
  ctx.fillRect(0,0,w,h);

  ctx.globalCompositeOperation = "destination-in";
  ctx.globalAlpha = 1;
  ctx.drawImage(baseImg, 0, 0, w, h);

  ctx.globalCompositeOperation = "overlay";
  ctx.globalAlpha = 0.55;
  ctx.drawImage(baseImg, 0, 0, w, h);

    // ✅ re-injecte le micro-contraste de la texture (base) pour éviter l'effet "plat"
  ctx.globalCompositeOperation = "soft-light";
  ctx.globalAlpha = 0.25;      // 0.18 à 0.35 selon rendu
  ctx.drawImage(baseImg, 0, 0, w, h);

  ctx.globalCompositeOperation = "screen";
  ctx.globalAlpha = 0.10;
  ctx.fillStyle = "#ffffff";
  ctx.fillRect(0,0,w,h);

  ctx.globalCompositeOperation = "destination-in";
  ctx.globalAlpha = 1;
  ctx.drawImage(baseImg, 0, 0, w, h);

  ctx.globalCompositeOperation = "source-over";
  ctx.globalAlpha = 1;
}

/******************************************************************
 * MOTIF RENDER PRO (warp + shadow/highlight + grain)
 ******************************************************************/

/** ✅ Grain cache (généré 1 fois) */
let _grainCanvas = null;

function getGrainCanvas(){
  if(_grainCanvas) return _grainCanvas;

  const c = document.createElement("canvas");
  c.width = 240;
  c.height = 240;

  const g = c.getContext("2d");
  const img = g.createImageData(c.width, c.height);

  for(let i=0; i<img.data.length; i+=4){
    const v = 180 + Math.random()*60; // 180..240
    img.data[i]   = v;
    img.data[i+1] = v;
    img.data[i+2] = v;
    img.data[i+3] = 255;
  }

  g.putImageData(img, 0, 0);
  _grainCanvas = c;
  return c;
}

/**
 * ✅ Dessine le motif “plein” + warp par bandes
 * ✅ MAJ : tuilage décalé type briques pour éviter les croisements visibles
 */
function drawPatternWithWarp(ctx, tileCanvas, w, h, zoom=1.0){
  if(!tileCanvas) return;

  const patternLayer = document.createElement("canvas");
  patternLayer.width = w;
  patternLayer.height = h;

  const pctx = patternLayer.getContext("2d");
  pctx.imageSmoothingEnabled = true;
  pctx.imageSmoothingQuality = "high";

  const scale = Math.max(0.35, zoom);
  const tileW = Math.max(120, Math.round(tileCanvas.width * scale));
  const tileH = Math.max(120, Math.round(tileCanvas.height * scale));
  const overlapX = Math.max(18, Math.round(tileW * 0.16));
  const overlapY = Math.max(18, Math.round(tileH * 0.14));
  const stepX = Math.max(40, tileW - overlapX);
  const stepY = Math.max(40, tileH - overlapY);
  const startX = -tileW;
  const startY = -tileH;
  const rowShift = Math.round(stepX * 0.5);

  for(let y = startY, row = 0; y < h + tileH; y += stepY, row++){
    const xOffset = (row % 2 === 0) ? 0 : rowShift;
    for(let x = startX - rowShift; x < w + tileW; x += stepX){
      const drawX = x + xOffset;
      const mirrorX = false;

      pctx.save();
      pctx.globalAlpha = 0.92;
      if(mirrorX){
        pctx.translate(drawX + tileW, y);
        pctx.scale(-1, 1);
        pctx.drawImage(tileCanvas, 0, 0, tileW, tileH);
      }else{
        pctx.drawImage(tileCanvas, drawX, y, tileW, tileH);
      }
      pctx.restore();
    }
  }

  pctx.save();
  pctx.globalAlpha = 0.20;
  pctx.filter = "blur(4px)";
  pctx.drawImage(patternLayer, 0, 0);
  pctx.restore();

  const amp = Math.max(5, Math.round(w * 0.009));
  const waves = 1.8;
  const stripH = 4;

  for(let y=0; y<h; y += stripH){
    const t = y / h;
    const offsetX = Math.round(Math.sin(t * Math.PI * 2 * waves) * amp);
    ctx.drawImage(patternLayer, 0, y, w, stripH, offsetX, y, w, stripH);

    if(offsetX > 0){
      ctx.drawImage(patternLayer, w - offsetX, y, offsetX, stripH, 0, y, offsetX, stripH);
    }else if(offsetX < 0){
      const ox = -offsetX;
      ctx.drawImage(patternLayer, 0, y, ox, stripH, w - ox, y, ox, stripH);
    }
  }
}

/**
 * Motif -> masque (pattern pro)
 * ✅ MAJ: applique MOTIF_SCALE (motif plus gros)
 */
function applyMotifToBaseMask(ctx, baseImg, motifTileCanvas, zoom=1.0){
  const w = ctx.canvas.width;
  const h = ctx.canvas.height;

  ctx.clearRect(0,0,w,h);
  ctx.imageSmoothingEnabled = true;

  // 1) motif warp / fallback
  if(motifTileCanvas){
    drawPatternWithWarp(ctx, motifTileCanvas, w, h, zoom * MOTIF_SCALE);
  }else{
    ctx.fillStyle = "#f4efe6";
    ctx.fillRect(0,0,w,h);
  }

  // 2) masque alpha
  ctx.globalCompositeOperation = "destination-in";
  ctx.globalAlpha = 1;
  ctx.drawImage(baseImg, 0, 0, w, h);

  // 3) ombres via baseImg
  ctx.globalCompositeOperation = "multiply";
  ctx.globalAlpha = 0.55;
  ctx.drawImage(baseImg, 0, 0, w, h);

  // 4) micro-contraste
  ctx.globalCompositeOperation = "overlay";
  ctx.globalAlpha = 0.22;
  ctx.drawImage(baseImg, 0, 0, w, h);

  // 5) highlights
  ctx.globalCompositeOperation = "screen";
  ctx.globalAlpha = 0.08;
  ctx.fillStyle = "#ffffff";
  ctx.fillRect(0,0,w,h);

  // 6) grain subtil
  const grain = getGrainCanvas();
  ctx.globalCompositeOperation = "soft-light";
  ctx.globalAlpha = 0.07;
  for(let yy=0; yy<h; yy+=grain.height){
    for(let xx=0; xx<w; xx+=grain.width){
      ctx.drawImage(grain, xx, yy);
    }
  }

  // 7) re-masque
  ctx.globalCompositeOperation = "destination-in";
  ctx.globalAlpha = 1;
  ctx.drawImage(baseImg, 0, 0, w, h);

  ctx.globalCompositeOperation = "source-over";
  ctx.globalAlpha = 1;
}

/******************************************************************
 * Render brins — Motifs + Couleurs
 ******************************************************************/
function renderStrand(strandIndex){
  const fabricKey = BRAID.currentFabrics[strandIndex] || "doudou";
  const c = strandCanvasMap[strandIndex];
  const ctx = c.getContext("2d");

  // ✅ tissus motifs
  if(isMotifFabric(fabricKey)){
    const m = BRAID.currentMotifs[strandIndex];

    const base = resolveBaseImage(strandIndex);
    if(!base || !base.complete || base.naturalWidth === 0) return;

    const tmp = offscreenMap[strandIndex];
    const tctx = tmp.getContext("2d");

    let tile = null;
    let motifImg = null;
    if(m){
      const filename = getMotifFileFor(m.name);
      motifImg = filename ? getMotifImgByFilename(filename) : null;
      tile = getMotifTileCanvas(m.id);
    }

    if(motifImg && motifImg.complete && motifImg.naturalWidth > 0 && motifImg.naturalHeight > 0){
      // Priorité à l'image motif directe pour garantir un rendu visible au clic.
      applyMotifImageDirectToBaseMask(tctx, base, motifImg, getBraidSettings().textureZoom || 1.0);
    }else if(tile){
      applyMotifToBaseMask(tctx, base, tile, getBraidSettings().textureZoom || 1.0);
    }else{
      applyMotifToBaseMask(tctx, base, null, getBraidSettings().textureZoom || 1.0);
    }

    ctx.clearRect(0,0,c.width,c.height);
    ctx.drawImage(tmp, 0, 0);
    return;
  }

  // ✅ tissus couleurs
const fabricKey2 = BRAID.currentFabrics[strandIndex] || "doudou";
const base = resolveBaseImage(strandIndex);
if(!base || !base.complete || base.naturalWidth === 0) return;

const tmp = offscreenMap[strandIndex];
const tctx = tmp.getContext("2d");

const color = BRAID.currentColors[strandIndex];
if(!color || !color.hex) return;

if(FORCE_MASTER_GEOMETRY_FOR_5BRINS && BRAID.type === "5" &&
   (fabricKey2 === "nid_abeille" || fabricKey2 === "cotele")){
  applyFabricColorWithTexture(tctx, base, color.hex, fabricKey2);
} else {
  tintBaseImage(tctx, base, color.hex);
}

const c2 = strandCanvasMap[strandIndex];
const ctx2 = c2.getContext("2d");
ctx2.clearRect(0,0,c2.width,c2.height);
ctx2.drawImage(tmp, 0, 0);
}

const BRAID_FRAME = {
  enabled: true,
  backFile: "fond_tresse.png",
  frontFile: "front_tresse.png",
  alpha: 1.0,

  // ✅ AJOUT : zoom du fond et du front
  backScale: 2.8,   // augmente si pas assez grand (ex: 1.45)
  frontScale: 2.8,  // idem

  // ✅ AJOUT : décalage fin si besoin (en px)
  backOffsetX: 300,
  backOffsetY: 70,
  frontOffsetX: 300,
  frontOffsetY: 70,

  braidRotationDeg: 2.2, // monte vers la gauche
    // ✅ NOUVEAU
  braidOffsetX: -0.005,   // ← 0.5% vers la gauche
    // ✅ offset Y par type de tresse
  braidOffsetYByType: {
    "3": 390,
    "4": 380,
    "5": 340,
    "3xxl": 340
  }
};


function drawImageContain(ctx, img, x, y, w, h){
  const iw = img.naturalWidth || img.width;
  const ih = img.naturalHeight || img.height;
  if(!iw || !ih) return;

  const s = Math.min(w / iw, h / ih);
  const tw = iw * s;
  const th = ih * s;
  const dx = x + (w - tw) / 2;
  const dy = y + (h - th) / 2;

  ctx.drawImage(img, dx, dy, tw, th);
}

function renderFinalBraid(){
  const w = finalCanvas.width;
  const h = finalCanvas.height;
  const fctx = finalCanvas.getContext("2d");

  fctx.clearRect(0,0,w,h);

  // 1) BACK (selon univers)
  const U = BRAID_UNIVERSES[BRAID.universe] || BRAID_UNIVERSES.studio;

  if(U.frameEnabled){
    const back = getImg(U.backFile);
    if(back && back.complete && back.naturalWidth > 0){
      fctx.save();
      fctx.globalAlpha = U.alpha ?? 1.0;
      drawImageCover(
        fctx, back, 0, 0, w, h,
        U.backScale ?? 1.0,
        U.backOffsetX ?? 0,
        U.backOffsetY ?? 0
      );
      fctx.restore();
    }
  }

 // 2) TRESSE (tes brins)
const angle =
  (BRAID.type === "5")
    ? (BRAID_FRAME.braidRotationDeg || 0) * Math.PI / 180
    : 0;

const offsetRatio =
  (BRAID.type === "5")
    ? (BRAID_FRAME.braidOffsetX || 0)
    : 0;

const offsetX = w * offsetRatio;

// ✅ NOUVEAU : offset vertical (pixels)
const offsetY =
  (BRAID_FRAME.braidOffsetYByType && BRAID_FRAME.braidOffsetYByType[BRAID.type] != null)
    ? BRAID_FRAME.braidOffsetYByType[BRAID.type]
    : 0;

fctx.save();

// ✅ centre + offsets X/Y
fctx.translate(w/2 + offsetX, h/2 + offsetY);

// rotation perspective
fctx.rotate(angle);

// retour repère
fctx.translate(-w/2, -h/2);

// draw tresse
for(let i=1; i<=BRAID.strandCount; i++){
  fctx.drawImage(strandCanvasMap[i], 0, 0);
}

fctx.restore();

  // 3) FRONT (selon univers)
  if(U.frameEnabled && U.frontFile){
    const front = getImg(U.frontFile);
    if(front && front.complete && front.naturalWidth > 0){
      fctx.save();
      fctx.globalAlpha = U.alpha ?? 1.0;
      drawImageCover(
        fctx, front, 0, 0, w, h,
        U.frontScale ?? 1.0,
        U.frontOffsetX ?? 0,
        U.frontOffsetY ?? 0
      );
      fctx.restore();
    }
  }
}  





/******************************************************************
 * UI (rows + swatches)
 ******************************************************************/
function initDefaultStrands(){
  const sc = BRAID.strandCount;

  for(let i=1; i<=sc; i++){
    BRAID.currentFabrics[i] = "doudou";
  }

  const p = getPalette("doudou");
  const base = [p[0], p[1]||p[0], p[3]||p[0], p[4]||p[0], p[16]||p[0]].filter(Boolean);

  BRAID.currentColors = {};
  for(let i=1; i<=sc; i++){
    const c = base[i-1] || p[(i-1) % p.length];
    BRAID.currentColors[i] = { name: c.name, hex: c.hex };
  }

  const m0 = motifById(1);
  BRAID.currentMotifs = {};
  for(let i=1; i<=sc; i++){
    BRAID.currentMotifs[i] = m0 ? { id: m0.id, name: m0.name } : null;
  }
}


function getFabricOptions(){
  return [
    { key: "doudou", label: "Doudou" },
    { key: "cotele", label: "Côtelé" },
    { key: "nid_abeille", label: "Nid d’abeille" },
    { key: "lisse_synthetique", label: "Motifs" },
  ];
}

function getCurrentSelectionLabel(strandIndex){
  const fabricKey = BRAID.currentFabrics[strandIndex] || "doudou";
  const fabricLabel = FABRIC_LABELS[fabricKey] || fabricKey;
  if(isMotifFabric(fabricKey)){
    const motifLabel = BRAID.currentMotifs[strandIndex]?.name || "Motif";
    return `${fabricLabel} · ${motifLabel}`;
  }
  const colorLabel = BRAID.currentColors[strandIndex]?.name || "Couleur";
  return `${fabricLabel} · ${colorLabel}`;
}

function getColorVisualUrl(fabricKey, colorName){
  const file = getExistingColorFile(fabricKey, colorName);
  return file ? fileUrl(file) : '';
}

function createFabricChip(option, active, strandIndex){
  const btn = document.createElement('button');
  btn.type = 'button';
  btn.className = 'compact-fabric-chip' + (active ? ' active' : '');
  btn.dataset.action = 'select-fabric';
  btn.dataset.strand = String(strandIndex);
  btn.dataset.fabric = option.key;
  btn.textContent = option.label;
  btn.setAttribute('aria-pressed', active ? 'true' : 'false');
  return btn;
}

function createColorSwatchButton(strandIndex, fabricKey, color, active){
  const btn = document.createElement('button');
  btn.type = 'button';
  btn.className = 'compact-color-swatch' + (active ? ' active' : '');
  btn.dataset.action = 'select-color';
  btn.dataset.strand = String(strandIndex);
  btn.dataset.color = color.name;
  btn.setAttribute('aria-label', color.name);
  btn.setAttribute('title', color.name);
  btn.setAttribute('aria-pressed', active ? 'true' : 'false');
  btn.style.backgroundImage = `url("${getColorVisualUrl(fabricKey, color.name)}")`;
  return btn;
}

function refreshAccordionSummaries(){
  strandRows.querySelectorAll('.strand-accordion').forEach(acc => {
    const strandIndex = Number(acc.dataset.strand);
    const summary = acc.querySelector('.strand-accordion-summary');
    if(summary) summary.textContent = getCurrentSelectionLabel(strandIndex);
  });
}

function setAccordionState(accordion, isOpen){
  if(!accordion) return;
  accordion.classList.toggle('is-open', !!isOpen);
  const btn = accordion.querySelector('.strand-accordion-trigger');
  const panel = accordion.querySelector('.strand-accordion-panel');
  if(btn) btn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
  if(panel){
    panel.hidden = !isOpen;
    panel.style.display = isOpen ? 'flex' : 'none';
  }
}

function openStrandAccordion(strandIndex){
  const target = strandRows.querySelector(`.strand-accordion[data-strand="${strandIndex}"]`);
  const shouldOpen = !(target && target.classList.contains('is-open'));

  strandRows.querySelectorAll('.strand-accordion').forEach(acc => {
    const isTarget = Number(acc.dataset.strand) === Number(strandIndex);
    setAccordionState(acc, isTarget ? shouldOpen : false);
  });
}

function buildStrandRows(){
  strandRows.innerHTML = '';
  const sc = BRAID.strandCount;

  for(let i=1; i<=sc; i++){
    const accordion = document.createElement('section');
    accordion.className = 'strand-accordion';
    accordion.dataset.strand = String(i);

    const trigger = document.createElement('button');
    trigger.type = 'button';
    trigger.className = 'strand-accordion-trigger';
    trigger.dataset.action = 'toggle-strand';
    trigger.dataset.strand = String(i);
    trigger.setAttribute('aria-expanded', 'false');

    const titleWrap = document.createElement('div');
    titleWrap.className = 'strand-accordion-headtext';

    const title = document.createElement('span');
    title.className = 'strand-accordion-title';
    title.textContent = `Brin ${i}`;

    const summary = document.createElement('span');
    summary.className = 'strand-accordion-summary';
    summary.textContent = getCurrentSelectionLabel(i);

    titleWrap.appendChild(title);
    titleWrap.appendChild(summary);

const icon = document.createElement('span');
icon.className = 'strand-accordion-icon';
icon.setAttribute('aria-hidden', 'true');
icon.innerHTML = `
  <svg viewBox="0 0 24 24" fill="none" aria-hidden="true" focusable="false">
    <path
      d="M7 10L12 15L17 10"
      stroke="currentColor"
      stroke-width="2.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
`;

    trigger.appendChild(titleWrap);
    trigger.appendChild(icon);

    const panel = document.createElement('div');
    panel.className = 'strand-accordion-panel';
    panel.hidden = true;
    panel.style.display = 'none';

    const fabricBlock = document.createElement('div');
    fabricBlock.className = 'compact-choice-block';

    const fabricLabel = document.createElement('div');
    fabricLabel.className = 'compact-choice-label';
    fabricLabel.textContent = 'Tissu';
    fabricBlock.appendChild(fabricLabel);

    const fabricOptionsWrap = document.createElement('div');
    fabricOptionsWrap.className = 'compact-fabric-list';
    getFabricOptions().forEach(opt => {
      const isActive = (BRAID.currentFabrics[i] || 'doudou') === opt.key;
      fabricOptionsWrap.appendChild(createFabricChip(opt, isActive, i));
    });
    fabricBlock.appendChild(fabricOptionsWrap);

    const colorBlock = document.createElement('div');
    colorBlock.className = 'compact-choice-block';
    const colorLabel = document.createElement('div');
    colorLabel.className = 'compact-choice-label';
    colorLabel.textContent = 'Couleur';
    colorBlock.appendChild(colorLabel);

    const swatchGrid = document.createElement('div');
    swatchGrid.className = 'compact-color-grid';
    swatchGrid.dataset.role = 'color-grid';
    swatchGrid.dataset.strand = String(i);
    colorBlock.appendChild(swatchGrid);

    panel.appendChild(fabricBlock);
    panel.appendChild(colorBlock);

    accordion.appendChild(trigger);
    accordion.appendChild(panel);
    strandRows.appendChild(accordion);
  }

  renderAllSwatches();
  refreshAccordionSummaries();
}
function toSlug(name){
  return String(name || "")
    .toLowerCase()
    .trim()
    .normalize("NFD").replace(/[\u0300-\u036f]/g, "") // accents
    .replace(/['’]/g, "")
    .replace(/\s+/g, "-");
}

/** ✅ slug spécial pour tes couleurs (vert d'eau, etc.) */
function toColorSlug(name){
  const s = toSlug(name);
  // vert d'eau -> vert-deau (comme ton naming probable)
  return s
    .replace(/vert-d-eau/g, "vert-deau")
    .replace(/vert-d-eau/g, "vert-deau");
}

/** ✅ Construit les noms possibles de fichiers couleur (PNG + JPG) */
function getColorFileCandidates(fabricKey, colorName){
  const c = toColorSlug(colorName);
  const candidates = [];

  if(fabricKey === "nid_abeille"){
    candidates.push(
      `nid-d-abeille-${c}.png`,
      `nid-d-abeille-${c}.jpg`
    );

    // alias historiques / fautes de naming déjà rencontrées
    if(c === 'bleu-moyen'){
      candidates.push('nid-d-bleu-moyen.png', 'nid-d-bleu-moyen.jpg');
    }
  }else if(fabricKey === "cotele"){
    candidates.push(`cotele-${c}.png`, `cotele-${c}.jpg`);
  }else{
    // doudou par défaut
    candidates.push(`doudou-${c}.png`, `doudou-${c}.jpg`);
  }

  return [...new Set(candidates)];
}

function getExistingColorFile(fabricKey, colorName){
  const candidates = getColorFileCandidates(fabricKey, colorName);
  const found = candidates.find(name => window.SISSOU_FILES && window.SISSOU_FILES[name]);
  return found || candidates[0] || null;
}

/** ✅ Motifs : JPG + PNG dédiés + aliases de secours */
const MOTIF_FILE_ALIASES = {
  "jungo": ["jungle.jpg", "jungo.jpg", "jungle.png", "jungo.png"],
  "foret": ["foret.jpg", "foret.png"],
  "fusee": ["fusee.jpg", "fusée.jpg", "fusee.png", "fusée.png"],
  "petit-coeur-rose": ["petit-coeur-rose.jpg", "petit-coeur.jpg", "petit-coeur-rose.png", "petit-coeur.png"],
  "fleurs-d-ete": ["fleurs-d-ete.jpg", "fleurs-ete.jpg", "fleurs-d-ete.png", "fleurs-ete.png"],
  "dahlia": ["nid-d-abeille-dahlia.jpg", "nid-d-abeille-dahlia.png", "dahlia.jpg", "dahlia.png"],
  "birdy": ["birdy.png", "birdy.jpg"]
};

function getMotifFileCandidates(motifName){
  const slug = toSlug(motifName);
  const aliases = MOTIF_FILE_ALIASES[slug] || [];
  return [...new Set([
    ...aliases,
    `${slug}.jpg`,
    `${slug}.png`
  ])];
}

function getMotifFileFor(motifName){
  const candidates = getMotifFileCandidates(motifName);
  const found = candidates.find(name => window.SISSOU_FILES && window.SISSOU_FILES[name]);
  return found || candidates[0] || null;
}

function setSelectSwatch(selectEl, filename){

  /* ✅ maintenant on cible le BON wrapper */
  const wrap = selectEl.closest(".selectPill");
  if(!wrap) return;

  if(!filename){
    wrap.style.setProperty("--swatchUrl", "none");
    wrap.style.backgroundImage = "none";
    return;
  }

  const url = fileUrl(filename); // SISSOU_FILES

  /* ✅ variable CSS utilisée par ton CSS */
  wrap.style.setProperty("--swatchUrl", `url("${url}")`);

  /* ✅ fallback sécurité */
  wrap.style.backgroundImage = `url("${url}")`;
}



const MOTIF_BATCH_SIZE = 12;
const motifVisibleCountByStrand = {};

function renderMotifBatch(grid, strandIndex, count){
  const visible = MOTIFS.slice(0, count);

  visible.forEach(m => {
    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'compact-color-swatch motif' + ((BRAID.currentMotifs[strandIndex]?.id === m.id) ? ' active' : '');
    btn.dataset.action = 'select-motif';
    btn.dataset.strand = String(strandIndex);
    btn.dataset.motifId = String(m.id);
    btn.setAttribute('aria-label', m.name);
    btn.setAttribute('title', m.name);

    const jpg = getMotifFileFor(m.name);
    if(jpg && window.SISSOU_FILES && window.SISSOU_FILES[jpg]){
      const url = fileUrl(jpg);
      btn.style.backgroundImage = `url("${url}")`;
      btn.style.backgroundSize = "cover";
      btn.style.backgroundPosition = "center";
    }else{
      btn.classList.add("is-missing");
      btn.style.background = "linear-gradient(135deg,#f7f3ee,#ebe2d6)";
    }

    grid.appendChild(btn);
  });

  if(count < MOTIFS.length){
    const moreBtn = document.createElement('button');
    moreBtn.type = 'button';
    moreBtn.className = 'compact-motif-more-btn';
    moreBtn.dataset.action = 'show-more-motifs';
    moreBtn.dataset.strand = String(strandIndex);
    moreBtn.textContent = `Voir plus (${MOTIFS.length - count})`;
    grid.appendChild(moreBtn);
  }
}


function renderSwatchesForStrand(strandIndex){
  const grid = strandRows.querySelector(`.compact-color-grid[data-strand="${strandIndex}"]`);
  if(!grid) return;

  grid.innerHTML = '';
  const fabricKey = BRAID.currentFabrics[strandIndex] || 'doudou';

if(isMotifFabric(fabricKey)){
  const count = motifVisibleCountByStrand[strandIndex] || MOTIF_BATCH_SIZE;
  renderMotifBatch(grid, strandIndex, count);
  return;
}

  const palette = getPalette(fabricKey);
  const currentName = BRAID.currentColors[strandIndex]?.name || palette[0]?.name;
  palette.forEach(color => {
    const active = color.name === currentName;
    grid.appendChild(createColorSwatchButton(strandIndex, fabricKey, color, active));
  });
}

function renderAllSwatches(){
  for(let i=1; i<=BRAID.strandCount; i++){
    renderSwatchesForStrand(i);
  }
  refreshAccordionSummaries();
}

function updateTexts(){
  const parts = [];
  for(let i=1; i<=BRAID.strandCount; i++){
    const f = BRAID.currentFabrics[i] || "doudou";
    const fLabel = FABRIC_LABELS[f] || f;

    if(isMotifFabric(f)){
      const mName = BRAID.currentMotifs[i]?.name || "—";
      parts.push(`Brin ${i}: ${fLabel} / ${mName}`);
    }else{
      const cName = BRAID.currentColors[i]?.name || "—";
      parts.push(`Brin ${i}: ${fLabel} / ${cName}`);
    }
  }

  const paletteText = parts.join(" · ");
  BRAID.currentPaletteText = paletteText;

  // ✅ Type
  if(braidPreviewTitle) braidPreviewTitle.textContent = `Aperçu – ${braidTypeLabel(BRAID.type)}`;
  if(previewBraidTypeEl) previewBraidTypeEl.textContent = braidTypeLabel(BRAID.type);

  // ✅ Palette (tu as supprimé le HTML => on protège)
  if(previewColors) previewColors.textContent = paletteText || "—";

  // ✅ Résumé (DOIT exister)
  if(summaryText) summaryText.textContent = `${braidTypeLabel(BRAID.type)} · ${paletteText}`.trim();

  refreshAccordionSummaries();
  renderCalcAndSummary();
  requestAnimationFrame(drawBed);
}

function renderAllStrands(){
  checkAssets();
  resizeFinalToFirstAvailable();

  for(let i=1; i<=BRAID.strandCount; i++){
    renderStrand(i);
  }
  renderFinalBraid();
  updateTexts();
}

function bindStrandUI(){
  strandRows.addEventListener('click', (e) => {
    const toggleBtn = e.target.closest('[data-action="toggle-strand"]');
    if(toggleBtn){
      openStrandAccordion(Number(toggleBtn.dataset.strand));
      return;
    }

    const fabricBtn = e.target.closest('[data-action="select-fabric"]');
    if(fabricBtn){
      const strand = Number(fabricBtn.dataset.strand);
      const fabricKey = fabricBtn.dataset.fabric;
      BRAID.currentFabrics[strand] = fabricKey;

      if(isMotifFabric(fabricKey)){
        const m0 = motifById(1);
        BRAID.currentMotifs[strand] = m0 ? { id: m0.id, name: m0.name } : null;
        if(m0){
          const filename = getMotifFileFor(m0.name);
          if(filename) getMotifImgByFilename(filename);
        }
      }else{
        const pal = getPalette(fabricKey);
        const first = pal[0] || { name:'Blanc', hex:'#F7F5F1' };
        BRAID.currentColors[strand] = { name: first.name, hex: first.hex };
      }

      const wrap = fabricBtn.closest('.compact-fabric-list');
      if(wrap){
        wrap.querySelectorAll('.compact-fabric-chip').forEach(btn => {
          const active = btn === fabricBtn;
          btn.classList.toggle('active', active);
          btn.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
      }

      renderSwatchesForStrand(strand);
      refreshAccordionSummaries();
      renderAllStrands();
      return;
    }

    const colorBtn = e.target.closest('[data-action="select-color"]');
    if(colorBtn){
      const strand = Number(colorBtn.dataset.strand);
      const fabricKey = BRAID.currentFabrics[strand] || 'doudou';
      const name = colorBtn.dataset.color;
      const pal = getPalette(fabricKey);
      const found = pal.find(c => c.name === name);
      if(found){
        BRAID.currentColors[strand] = { name: found.name, hex: found.hex };
        renderSwatchesForStrand(strand);
        refreshAccordionSummaries();
        renderAllStrands();
      }
      return;
    }

const moreMotifsBtn = e.target.closest('[data-action="show-more-motifs"]');
if(moreMotifsBtn){
  const strand = Number(moreMotifsBtn.dataset.strand);
  const current = motifVisibleCountByStrand[strand] || MOTIF_BATCH_SIZE;
  motifVisibleCountByStrand[strand] = current + MOTIF_BATCH_SIZE;
  renderSwatchesForStrand(strand);
  return;
}


   const motifBtn = e.target.closest('[data-action="select-motif"]');
if(motifBtn){
  const strand = Number(motifBtn.dataset.strand);
  const id = Number(motifBtn.dataset.motifId);
  const m = motifById(id);

  if(m){
    BRAID.currentMotifs[strand] = { id: m.id, name: m.name };

    const filename = getMotifFileFor(m.name);
    if(filename) getMotifImgByFilename(filename);

    const grid = strandRows.querySelector(`.compact-color-grid[data-strand="${strand}"]`);
    if(grid){
      grid.querySelectorAll('[data-action="select-motif"]').forEach(btn => {
        btn.classList.toggle('active', btn === motifBtn);
      });
    }

    refreshAccordionSummaries();
    renderAllStrands();
  }
  return;
}
  });
}

function rebuildBraidPipeline(){
  ensureStrandCanvases();
  buildStrandRows();
  renderAllSwatches();

  for(let i=1;i<=BRAID.strandCount;i++){
    getBaseImg(baseImagePathFor(i, "doudou"));
  }
  renderAllStrands();
}

function getBraidTypeFromUrl(){
  try {
    const params = new URLSearchParams(window.location.search);
    const braid = String(params.get("braid") || "").trim().toLowerCase();
    return ["3", "4", "5", "3xxl"].includes(braid) ? braid : null;
  } catch(err) {
    return null;
  }
}

function setBraidTypeInUrl(type){
  try {
    const url = new URL(window.location.href);
    url.searchParams.set("braid", type);
    window.history.replaceState({}, "", url.toString());
  } catch(err) {
    console.warn("[CONFIG TRESSE] impossible de synchroniser l'URL", err);
  }
}

function applyBraidType(type, syncUrl = false){
  if(!["3", "4", "5", "3xxl"].includes(type)) return;

  [...braidTypeChips.querySelectorAll("button[data-braid-type]")].forEach(b => {
    b.classList.toggle("active", b.dataset.braidType === type);
  });

  BRAID.type = type;

  initDefaultStrands();
  rebuildBraidPipeline();

  refreshKnownSizeEntry();
  refreshMiniBraidOption();
  renderCalcAndSummary();

  if(bedCanvas) requestAnimationFrame(drawBed);

  if(syncUrl){
    setBraidTypeInUrl(type);
  }
}

function bindBraidTypeUI(){
  braidTypeChips.addEventListener("click", (e) => {
    const btn = e.target.closest("button[data-braid-type]");
    if(!btn) return;
    applyBraidType(btn.dataset.braidType, true);
  });
}



/******************************************************************
 * ================================================================
 * PIXEL PERFECT 5 BRINS
 * Géométrie = TOUJOURS doudou (master)
 * Tissus nid_abeille / cotele simulés par texture procédurale
 * ================================================================
 ******************************************************************/

var FORCE_MASTER_GEOMETRY_FOR_5BRINS = false;

/******************************************************************
 * TEXTURES PREMIUM (côtelé / nid d’abeille)
 * Remplace getFabricTileCanvas() + applyFabricColorWithTexture()
 ******************************************************************/

const fabricTileCache = {};

/** petit bruit “fibres” (réutilisé) */
function makeNoiseTile(size=256, amount=0.18){
  const c = document.createElement("canvas");
  c.width = size; c.height = size;
  const ctx = c.getContext("2d");
  const img = ctx.createImageData(size, size);

  // bruit doux + un peu de “banding” vertical pour simuler fibres
  for(let y=0; y<size; y++){
    const band = (Math.sin(y * 0.08) + Math.sin(y * 0.013)) * 10; // fibres verticales très faibles
    for(let x=0; x<size; x++){
      const i = (y*size + x) * 4;
      const n = (Math.random()*255);
      let v = n + band;

      // clamp
      v = v < 0 ? 0 : (v > 255 ? 255 : v);

      img.data[i]   = v;
      img.data[i+1] = v;
      img.data[i+2] = v;
      img.data[i+3] = Math.round(255 * amount);
    }
  }
  ctx.putImageData(img, 0, 0);
  return c;
}

/** emboss léger depuis l’alpha du masque (simule relief directionnel) */
function embossFromAlpha(ctx, baseImg, w, h, strength=0.8){
  // on récupère l’alpha du masque
  const tmp = document.createElement("canvas");
  tmp.width = w; tmp.height = h;
  const tctx = tmp.getContext("2d");
  tctx.clearRect(0,0,w,h);
  tctx.drawImage(baseImg, 0, 0, w, h);

  const data = tctx.getImageData(0,0,w,h);
  const out  = ctx.createImageData(w,h);

  // lumière haut-gauche -> ombre bas-droite
  const lx = -1, ly = -1;
  const norm = Math.hypot(lx,ly) || 1;
  const Lx = lx/norm, Ly = ly/norm;

  const idx = (x,y)=> (y*w+x)*4;

  for(let y=1; y<h-1; y++){
    for(let x=1; x<w-1; x++){
      const i = idx(x,y);
      // alpha voisinage
      const aL = data.data[idx(x-1,y)+3] / 255;
      const aR = data.data[idx(x+1,y)+3] / 255;
      const aU = data.data[idx(x,y-1)+3] / 255;
      const aD = data.data[idx(x,y+1)+3] / 255;

      // gradient
      const gx = (aR - aL);
      const gy = (aD - aU);

      // dot avec lumière (relief)
      let shade = (gx*Lx + gy*Ly) * 0.5 * strength;
      // convert en gris (128 = neutre)
      const v = Math.round(128 + shade*255);

      out.data[i]   = v;
      out.data[i+1] = v;
      out.data[i+2] = v;
      out.data[i+3] = Math.round(255 * 0.22); // alpha faible
    }
  }
  ctx.putImageData(out,0,0);
}

/** ✅ Tile tissu premium */
function getFabricTileCanvas(fabricKey){
  if(fabricTileCache[fabricKey]) return fabricTileCache[fabricKey];

  const tile = document.createElement("canvas");
  tile.width = 360;
  tile.height = 360;
  const ctx = tile.getContext("2d");
  ctx.clearRect(0,0,tile.width,tile.height);
  ctx.imageSmoothingEnabled = true;

  // bruit fibres commun
  const noise = makeNoiseTile(256, 0.20);

  // couche base (micro variations)
  ctx.save();
  ctx.globalAlpha = 0.65;
  for(let y=0; y<tile.height; y+=noise.height){
    for(let x=0; x<tile.width; x+=noise.width){
      ctx.drawImage(noise, x, y);
    }
  }
  ctx.restore();

  if(fabricKey === "cotele"){
    // ===== CÔTELÉ PREMIUM =====
    // stries verticales avec irrégularité + highlight directionnel
    const ribBase = 14;                 // largeur moyenne d’une côte
    const jitter  = 3;                  // irrégularité
    const H = tile.height;

    for(let x=0; x<tile.width; ){
      const ribW = ribBase + (Math.random()*jitter*2 - jitter);
      const g = ctx.createLinearGradient(x, 0, x + ribW, 0);

      // profil: ombre -> highlight -> ombre
      g.addColorStop(0.00, "rgba(0,0,0,.18)");
      g.addColorStop(0.18, "rgba(0,0,0,.06)");
      g.addColorStop(0.45, "rgba(255,255,255,.24)");
      g.addColorStop(0.62, "rgba(0,0,0,.05)");
      g.addColorStop(1.00, "rgba(0,0,0,.14)");

      ctx.fillStyle = g;
      ctx.fillRect(x, 0, ribW, H);

      // micro “fils” verticaux
      ctx.save();
      ctx.globalAlpha = 0.10;
      ctx.fillStyle = "rgba(255,255,255,.8)";
      for(let k=0;k<2;k++){
        const fx = x + Math.random()*ribW;
        ctx.fillRect(fx, 0, 1, H);
      }
      ctx.restore();

      x += ribW;
    }

    // voile satin léger (premium)
    ctx.save();
    ctx.globalCompositeOperation = "soft-light";
    ctx.globalAlpha = 0.35;
    const sheen = ctx.createLinearGradient(0,0,tile.width,tile.height);
    sheen.addColorStop(0,"rgba(255,255,255,.35)");
    sheen.addColorStop(1,"rgba(0,0,0,.18)");
    ctx.fillStyle = sheen;
    ctx.fillRect(0,0,tile.width,tile.height);
    ctx.restore();
  }

  else if(fabricKey === "nid_abeille"){
    // ===== NID D’ABEILLE PREMIUM =====
    // on dessine des alvéoles plus fines + relief + irrégularité
    const step = 26;      // densité (plus petit = plus fin)
    const r = 7.5;        // arrondi alvéole
    const W = tile.width, H = tile.height;

    ctx.save();
    ctx.globalAlpha = 0.95;

    for(let y=-step; y<H+step; y+=step){
      const row = Math.round(y/step);
      const ox = (row % 2) ? step*0.5 : 0;

      for(let x=-step; x<W+step; x+=step){
        const cx = x + ox + (Math.random()*1.2 - 0.6); // irrégularité
        const cy = y + (Math.random()*1.2 - 0.6);

        // ombre interne (creux)
        ctx.beginPath();
        ctx.moveTo(cx, cy + step*0.20);
        ctx.lineTo(cx + step*0.30, cy);
        ctx.lineTo(cx + step*0.60, cy + step*0.20);
        ctx.lineTo(cx + step*0.30, cy + step*0.40);
        ctx.closePath();

        ctx.fillStyle = "rgba(0,0,0,.10)";
        ctx.fill();

        // highlight bord haut-gauche
        ctx.strokeStyle = "rgba(255,255,255,.22)";
        ctx.lineWidth = 2;
        ctx.stroke();

        // petit point de couture (fil)
        ctx.fillStyle = "rgba(255,255,255,.10)";
        ctx.fillRect(cx + step*0.25, cy + step*0.14, 1, 1);
      }
    }

    // voile directionnel (lumière)
    ctx.globalCompositeOperation = "overlay";
    ctx.globalAlpha = 0.35;
    const light = ctx.createLinearGradient(0,0,W,H);
    light.addColorStop(0,"rgba(255,255,255,.35)");
    light.addColorStop(1,"rgba(0,0,0,.22)");
    ctx.fillStyle = light;
    ctx.fillRect(0,0,W,H);

    ctx.restore();
  }

  fabricTileCache[fabricKey] = tile;
  return tile;
}

/******************************************************************
 * COLOR + TEXTURE PREMIUM SUR MASQUE MASTER
 ******************************************************************/
function applyFabricColorWithTexture(ctx, baseImg, hex, fabricKey){
  const w = ctx.canvas.width;
  const h = ctx.canvas.height;

  ctx.clearRect(0,0,w,h);
  ctx.imageSmoothingEnabled = true;

  // 1) base couleur (pleine)
  ctx.globalCompositeOperation = "source-over";
  ctx.globalAlpha = 1;
  ctx.fillStyle = hex;
  ctx.fillRect(0,0,w,h);

  // 2) texture tissu (repeat)
  const tile = getFabricTileCanvas(fabricKey);
  const pat = ctx.createPattern(tile, "repeat");
  if(pat){
    ctx.save();
    ctx.fillStyle = pat;

    // soft-light pour “matière”
    ctx.globalCompositeOperation = "soft-light";
    ctx.globalAlpha = 0.70;
    ctx.fillRect(0,0,w,h);

    // overlay pour “snap” premium
    ctx.globalCompositeOperation = "overlay";
    ctx.globalAlpha = 0.22;
    ctx.fillRect(0,0,w,h);
    ctx.restore();
  }

  // 3) relief global depuis le masque (emboss léger)
  ctx.save();
  ctx.globalCompositeOperation = "overlay";
  ctx.globalAlpha = 0.65;
  embossFromAlpha(ctx, baseImg, w, h, 0.55);
  ctx.restore();

  // 4) ombres / volumes réalistes via la géométrie master
  ctx.globalCompositeOperation = "multiply";
  ctx.globalAlpha = 0.78;
  ctx.drawImage(baseImg, 0, 0, w, h);

  ctx.globalCompositeOperation = "overlay";
  ctx.globalAlpha = 0.30;
  ctx.drawImage(baseImg, 0, 0, w, h);

  // 5) specular très léger (premium)
  ctx.globalCompositeOperation = "screen";
  ctx.globalAlpha = 0.06;
  const spec = ctx.createLinearGradient(0,0,w,h);
  spec.addColorStop(0,"rgba(255,255,255,.35)");
  spec.addColorStop(1,"rgba(255,255,255,0)");
  ctx.fillStyle = spec;
  ctx.fillRect(0,0,w,h);

  // 6) masque alpha final
  ctx.globalCompositeOperation = "destination-in";
  ctx.globalAlpha = 1;
  ctx.drawImage(baseImg, 0, 0, w, h);

  ctx.globalCompositeOperation = "source-over";
  ctx.globalAlpha = 1;
}

// ===============================
// ✅ Univers de rendu (Studio / Produit)
// ===============================
BRAID.universe = "produit"; // "studio" | "produit"

const BRAID_UNIVERSES = {
  studio: {
    label: "Studio",
    frameEnabled: true,
    backFile: "fond_tresse.png",
    frontFile: "front_tresse.png",
    backScale: BRAID_FRAME.backScale,
    frontScale: BRAID_FRAME.frontScale,
    backOffsetX: BRAID_FRAME.backOffsetX,
    backOffsetY: BRAID_FRAME.backOffsetY,
    frontOffsetX: BRAID_FRAME.frontOffsetX,
    frontOffsetY: BRAID_FRAME.frontOffsetY,
    alpha: BRAID_FRAME.alpha
  },

  produit: {
    label: "Produit",
    frameEnabled: true,
    // ✅ Ici tu mets ton fond produit
    backFile: "fond_tresse2.png",   // ou .png si tu préfères
    // ✅ Soit pas de front, soit un front "produit"
    frontFile: null,               // ex: "front_tresse_produit.png" si tu en as un
    backScale: 1.0,
    frontScale: 1.0,
    backOffsetX: 0,
    backOffsetY: 0,
    frontOffsetX: 0,
    frontOffsetY: 0,
    alpha: 1.0
  }
};


/***********************
 * CIEL DE LIT (CANOPY)
 ***********************/
const CANOPY = {
  enabled: true,
  baseFile: "ciel_base.png",
  maskFile: "ciel_mask.png",
  shadeFile: "ciel_shading.png",
  // tissus (tes 2 exemples)
fabrics: [
  // Pois dorés
  { key: "pois_blanc",      label: "Gaze pois dorés – Blanc",      file: "gaz_poids_dore_blanc.png" },
  { key: "pois_bleu",       label: "Gaze pois dorés – Bleu prince",file: "gaz_poids_dore_bleu_prince.png" },
  { key: "pois_bonbon",     label: "Gaze pois dorés – Bonbon",     file: "gaz_poids_dore_bonbon.png" },
  { key: "pois_chataigne",  label: "Gaze pois dorés – Châtaigne",  file: "gaz_poids_dore_chataigne.png" },
  { key: "pois_lavande",    label: "Gaze pois dorés – Lavande",    file: "gaz_poids_dore_lavande.png" },
  { key: "pois_petrol",     label: "Gaze pois dorés – Pétrole",    file: "gaz_poids_dore_petrol.png" },
  { key: "pois_terracotta", label: "Gaze pois dorés – Terracotta", file: "gaz_poids_dore_terracotta.png" },
  { key: "pois_vertdeau",   label: "Gaze pois dorés – Vert d’eau", file: "gaz_poids_dore_vert_deau.png" },

  // Unis
  { key: "uni_beige",     label: "Gaze unie – Beige",      file: "gaz_uni_beige.png" },
  { key: "uni_blanc",     label: "Gaze unie – Blanc",      file: "gaz_uni_blanc.png" },
  { key: "uni_bleu",      label: "Gaze unie – Bleu",       file: "gaz_uni_bleu.png" },
  { key: "uni_brique",    label: "Gaze unie – Brique",     file: "gaz_uni_brique.png" },
  { key: "uni_cafe",      label: "Gaze unie – Café",       file: "gaz_uni_cafe.png" },
  { key: "uni_camel",     label: "Gaze unie – Camel",      file: "gaz_uni_camel.png" },
  { key: "uni_creme",     label: "Gaze unie – Crème",      file: "gaz_uni_creme.png" },
  { key: "uni_ecru",      label: "Gaze unie – Écru",       file: "gaz_uni_ecru.png" },
  { key: "uni_gris",      label: "Gaze unie – Gris",       file: "gaz_uni_gris.png" },
  { key: "uni_marsala",   label: "Gaze unie – Marsala",    file: "gaz_uni_marsala.png" },
  { key: "uni_melon",     label: "Gaze unie – Melon",      file: "gaz_uni_melon.png" },
  { key: "uni_moutarde",  label: "Gaze unie – Moutarde",   file: "gaz_uni_moutarde.png" },
  { key: "uni_olive",     label: "Gaze unie – Olive",      file: "gaz_uni_olive.png" },
  { key: "uni_poudre",    label: "Gaze unie – Poudré",     file: "gaz_uni_poudre.png" },
  { key: "uni_roi",       label: "Gaze unie – Bleu roi",   file: "gaz_uni_roi.png" },
  { key: "uni_rose",      label: "Gaze unie – Rose",       file: "gaz_uni_rose.png" },
  { key: "uni_vertdeau",  label: "Gaze unie – Vert d’eau", file: "gaz_uni_vert_deau.png" },
  { key: "uni_vieuxrose", label: "Gaze unie – Vieux rose", file: "gaz_uni_vieux_rose.png" },
],
  // réglages rendu
  patternScale: 0.85,   // < 1 = motif plus gros ; > 1 = motif plus petit
  patternOpacity: 1.0,
  sheen: 0.10,          // petit voile lumière
};

const canopyCanvas = document.getElementById("canvas-canopy") || _fallbackCanvas;
const canopyCtx = canopyCanvas.getContext("2d");
const canopyChips = document.getElementById("canopyChips") || _fallbackEl();

// ✅ Offscreen layer pour composer le canopy sans casser la base
const canopyLayer = document.createElement("canvas");
const canopyLayerCtx = canopyLayer.getContext("2d");

function ensureCanopyLayerSize(W, H){
  if (canopyLayer.width !== W || canopyLayer.height !== H){
    canopyLayer.width = W;
    canopyLayer.height = H;
  }
}

const _imgCache = {};
function getImg(file){
  const url = fileUrl(file);
  if(_imgCache[url]) return _imgCache[url];
  const img = new Image();
  img.src = url;
  img.onload = () => renderCanopy();
  img.onerror = () => console.warn("Image introuvable:", url);
  _imgCache[url] = img;
  return img;
}

function ensureCanopyCanvasSizeFrom(img){
  if(!img || !img.complete || img.naturalWidth === 0) return false;

  const wantW = img.naturalWidth;
  const wantH = img.naturalHeight;

  if (canopyCanvas.width !== wantW || canopyCanvas.height !== wantH){
    canopyCanvas.width  = wantW;
    canopyCanvas.height = wantH;
  }
  return true;
}

/**
 * Dessine un tissu (image) en repeat dans un canvas de taille W×H
 * avec un scale (patternScale) stable.
 */
function fillWithTexturePattern(ctx, textureImg, W, H, patternScale=1.0, opacity=1.0){
  if(!textureImg || !textureImg.complete || textureImg.naturalWidth === 0) return false;

  const pat = ctx.createPattern(textureImg, "repeat");
  if(!pat) return false;

  ctx.save();
  ctx.globalAlpha = opacity;

  // scale du pattern (setTransform si dispo)
  if(typeof pat.setTransform === "function"){
    const m = new DOMMatrix();
    m.a = patternScale; // scaleX
    m.d = patternScale; // scaleY
    // tu peux aussi décaler un peu pour casser l'effet "pile"
    m.e = Math.round(textureImg.naturalWidth * 0.13);
    m.f = Math.round(textureImg.naturalHeight * 0.07);
    pat.setTransform(m);
    ctx.fillStyle = pat;
    ctx.fillRect(0, 0, W, H);
  } else {
    // fallback ancien navigateur
    ctx.scale(patternScale, patternScale);
    ctx.fillStyle = pat;
    ctx.fillRect(0, 0, W / patternScale, H / patternScale);
  }

  ctx.restore();
  return true;
}

function applyTextureToMask(targetCtx, maskImg, textureImg, W, H){
  // ✅ on compose dans un layer, pas sur le canvas final
  ensureCanopyLayerSize(W, H);

  const ctx = canopyLayerCtx;
  ctx.clearRect(0,0,W,H);
  ctx.imageSmoothingEnabled = true;

  // 1) couche tissu (repeat)
  const ok = fillWithTexturePattern(
    ctx,
    textureImg,
    W,
    H,
    CANOPY.patternScale,
    CANOPY.patternOpacity
  );

  if(!ok){
    ctx.fillStyle = "#f4efe6";
    ctx.fillRect(0,0,W,H);
  }

  // 2) petit voile lumière
  if(CANOPY.sheen > 0){
    ctx.save();
    ctx.globalCompositeOperation = "screen";
    ctx.globalAlpha = CANOPY.sheen;
    const g = ctx.createLinearGradient(0,0,W,H);
    g.addColorStop(0, "rgba(255,255,255,.6)");
    g.addColorStop(1, "rgba(255,255,255,0)");
    ctx.fillStyle = g;
    ctx.fillRect(0,0,W,H);
    ctx.restore();
  }

  // 3) masque alpha (forme)
  ctx.save();
  ctx.globalCompositeOperation = "destination-in";
  ctx.globalAlpha = 1;
  ctx.drawImage(maskImg, 0, 0, W, H);
  ctx.restore();

  // 4) shading / plis
  const shade = CANOPY.shadeFile ? getImg(CANOPY.shadeFile) : null;

  if(shade && shade.complete && shade.naturalWidth > 0){
    ctx.save();
    ctx.globalCompositeOperation = "multiply";
    ctx.globalAlpha = 0.55;
    ctx.drawImage(shade, 0, 0, W, H);
    ctx.restore();

    ctx.save();
    ctx.globalCompositeOperation = "overlay";
    ctx.globalAlpha = 0.25;
    ctx.drawImage(shade, 0, 0, W, H);
    ctx.restore();

    ctx.save();
    ctx.globalCompositeOperation = "screen";
    ctx.globalAlpha = 0.10;
    ctx.drawImage(shade, 0, 0, W, H);
    ctx.restore();
  } else {
    ctx.save();
    ctx.globalCompositeOperation = "multiply";
    ctx.globalAlpha = 0.18;
    ctx.drawImage(maskImg, 0, 0, W, H);
    ctx.restore();
  }

  // ✅ on colle le layer final sur le canvas principal SANS effacer la base
  targetCtx.drawImage(canopyLayer, 0, 0);
}

function renderCanopy(){
  if(!canopyCanvas) return;

  const base = CANOPY.baseFile ? getImg(CANOPY.baseFile) : null;
  const mask = getImg(CANOPY.maskFile);

  // On attend le mask (référence pixel-perfect)
  if(!mask || !mask.complete || mask.naturalWidth === 0){
    return;
  }

  // ✅ Canvas = EXACTEMENT la taille du mask (1500×1500 chez toi)
  ensureCanopyCanvasSizeFrom(mask);

  const W = canopyCanvas.width;
  const H = canopyCanvas.height;

  // 0) Base chambre
  canopyCtx.clearRect(0,0,W,H);
  if(base && base.complete && base.naturalWidth > 0){
    // pixel-perfect car base et mask ont la même taille
    canopyCtx.drawImage(base, 0, 0, W, H);
  }

  // 1) Tissu + mask + shading par-dessus (NE DOIT PAS clear le canvas)
  const fabric = CANOPY.fabrics.find(f => f.key === CANOPY.currentKey) || CANOPY.fabrics[0];
  const tex = getImg(fabric.file);

  applyTextureToMask(canopyCtx, mask, tex, W, H);
}


function buildCanopyChips(){
  if(!canopyChips) return;
  canopyChips.innerHTML = "";

  CANOPY.fabrics.forEach(f => {
    const b = document.createElement("button");
    b.type = "button";
    b.className = "chip" + (f.key === CANOPY.currentKey ? " active" : "");
    b.textContent = f.label;
    b.addEventListener("click", () => {
      CANOPY.currentKey = f.key;
      buildCanopyChips();
      renderCanopy();
    });
    canopyChips.appendChild(b);
  });
}


/******************************************************************
 * INIT GLOBAL
 ******************************************************************/
// ✅ INIT GLOBAL (TOUT EN BAS DU FICHIER)
(function initAll(){
  // bed init
  try {
    toggleCustomMode(false);
    renderPresetChips();
    syncInputsFromState();
    renderSegBadges();
    renderCalcAndSummary();
    if (document.getElementById("bedCanvas")) requestAnimationFrame(drawBed);
  } catch (err) {
    console.warn("[CONFIG TRESSE] blocs legacy lit ignorés", err);
  }

  // braid init
  initDefaultStrands();
  bindStrandUI();
  bindBraidTypeUI();
  rebuildBraidPipeline();

  const braidTypeFromUrl = getBraidTypeFromUrl();
  if(braidTypeFromUrl){
    applyBraidType(braidTypeFromUrl, false);
  }

  // canopy init
  buildCanopyChips();
  renderCanopy();

  // ===============================
// Toggle config ciel de lit
// ===============================
const canopyToggle = document.getElementById("toggleCanopyConfig");
const canopyCard   = document.getElementById("canopyCard");
const canopyPanel  = document.getElementById("canopyConfigWrapper"); // optionnel

if (canopyToggle && canopyCard) {
  // ✅ caché au chargement (sécurité)
  canopyCard.style.display = "none";
  if (canopyPanel) canopyPanel.style.display = "none";

  console.log("[CANOPY] toggle OK", { canopyToggle, canopyCard, canopyPanel });

  canopyToggle.addEventListener("dblclick", (e) => {
    e.preventDefault();
    e.stopPropagation();

    const isHidden = (getComputedStyle(canopyCard).display === "none");
    canopyCard.style.display = isHidden ? "block" : "none";

    // ✅ option : si on affiche la card, on peut afficher aussi le panel tissu
    // (ou le laisser caché si tu veux vraiment tout masquer)
    if (isHidden && canopyPanel) {
      canopyPanel.style.display = "block";
    }

    console.log("[CANOPY] dblclick -> canopyCard:", canopyCard.style.display);
  });
} else {
  console.warn("[CANOPY] toggle/canopyCard introuvables", { canopyToggle, canopyCard });
}



    // ✅ Toggle Univers (Studio / Produit)
  const toggleBtn = document.getElementById("toggleBraidUniverse");
  if(toggleBtn){
    const refreshLabel = () => {
      const U = BRAID_UNIVERSES[BRAID.universe] || BRAID_UNIVERSES.studio;
      toggleBtn.textContent = `Univers : ${U.label}`;
    };

    refreshLabel();

    toggleBtn.addEventListener("click", () => {
      BRAID.universe = (BRAID.universe === "studio") ? "produit" : "studio";
      refreshLabel();

      // redraw immédiat
      renderFinalBraid();

      // si tu veux que le canopy suive aussi :
      // renderCanopy(); // (optionnel)
    });
  }
})();




/***********************
 * COMPOSITING TRESSE DANS CANOPY (fond + tresse + front)
 ***********************/

// ✅ réglage placement (à ajuster une fois, puis c'est bon)
const TRESSE_OVERLAY = {
  enabled: true,
  backFile: "fond_tresse.png",
  frontFile: "front_tresse.png",

  // ✅ ta zone de destination (OK)
  targetRect: { x: 210, y: 670, w: 690, h: 135 },

  // ✅ ton crop (on garde ton intention mais on va le sécuriser au draw)
  srcRect: { x: -400, y: 200, w: 1800, h: 450 },

  alpha: 1.0
};

function drawImageCover(ctx, img, x, y, w, h, scale=1.0, offsetX=0, offsetY=0){
  const iw = img.naturalWidth || img.width;
  const ih = img.naturalHeight || img.height;
  if(!iw || !ih) return;

  const s = Math.max(w / iw, h / ih) * scale;
  const dw = iw * s;
  const dh = ih * s;

  const dx = x + (w - dw) / 2 + offsetX;
  const dy = y + (h - dh) / 2 + offsetY;

  ctx.drawImage(img, dx, dy, dw, dh);
}

/**
 * Compose dans canvas-canopy :
 * - canopy déjà dessiné par renderCanopy()
 * - + fond_tresse
 * - + tresse configurée (canvas-braid)
 * - + front_tresse
 */

function renderCanopyWithBraidOverlay(){
  if(!TRESSE_OVERLAY.enabled) return;
  if(!canopyCanvas || !canopyCtx) return;

  // 1) on part du rendu canopy actuel (déjà dessiné)
  // => on NE clear pas ici, sinon on efface le ciel de lit

  // 2) calque arrière
  const back = getImg(TRESSE_OVERLAY.backFile);
  if(back && back.complete && back.naturalWidth > 0){
    drawImageCover(canopyCtx, back, 0, 0, canopyCanvas.width, canopyCanvas.height);
  }

  // 3) tresse configurée (provenant du canvas tresse)
  // IMPORTANT : le canvas tresse n'a pas forcément la même taille
  const braidCanvas = document.getElementById("canvas-braid");
  if(braidCanvas && braidCanvas.width > 0 && braidCanvas.height > 0){
    const { x, y, w, h } = TRESSE_OVERLAY.targetRect;

    // Dessin complet OU crop partiel
    const s = TRESSE_OVERLAY.srcRect;
    if(s && typeof s.x === "number"){
      canopyCtx.drawImage(
        braidCanvas,
        s.x, s.y, s.w, s.h,   // source dans la tresse
        x, y, w, h            // destination dans canopy
      );
    } else {
      canopyCtx.drawImage(braidCanvas, x, y, w, h);
    }
  }

  // 4) calque avant (pour “rendre naturel”)
  const front = getImg(TRESSE_OVERLAY.frontFile);
  if(front && front.complete && front.naturalWidth > 0){
    drawImageCover(canopyCtx, front, 0, 0, canopyCanvas.width, canopyCanvas.height);
  }
}

/**
 * Hook : on “injecte” le compositing après chaque rendu canopy et après chaque rendu tresse.
 */
const _renderCanopyOriginal = renderCanopy;
renderCanopy = function(){
  _renderCanopyOriginal();
  // on compose juste après
  renderCanopyWithBraidOverlay();
};

// À chaque update tresse => on redessine le canopy + overlay
const _renderAllStrandsOriginal = renderAllStrands;
renderAllStrands = function(){
  _renderAllStrandsOriginal();
  // Recompose l'overlay (sans dépendre d'un click canopy)
  renderCanopy(); // cela redessine canopy + overlay
};





function hideLegacySummaryZones(){
  const hideNode = (node) => {
    if(!node) return;
    node.style.setProperty('display', 'none', 'important');
    node.setAttribute('hidden', 'hidden');
    node.setAttribute('aria-hidden', 'true');
  };

  document.querySelectorAll('#cardLitOptions, #cardSummary, #desiredBlock').forEach(hideNode);

  document.querySelectorAll('#desiredLen, #desiredRange, #desiredPrice').forEach((node) => {
    const zone = node.closest('.calc') || node.closest('.card');
    hideNode(zone);
  });

  document.querySelectorAll('#sumFinal, #sumBraidType, #sumColors').forEach((node) => {
    const zone = node.closest('.calc') || node.closest('.card');
    hideNode(zone);
  });
}

if(document.readyState === 'loading'){
  document.addEventListener('DOMContentLoaded', hideLegacySummaryZones);
}else{
  hideLegacySummaryZones();
}

setTimeout(hideLegacySummaryZones, 150);
setTimeout(hideLegacySummaryZones, 600);

new MutationObserver(() => hideLegacySummaryZones()).observe(document.documentElement, {
  childList: true,
  subtree: true
});
